export default {
    "scalars": [
        2,
        3,
        5,
        9,
        14,
        15,
        16,
        17,
        23,
        24,
        29,
        32,
        38,
        39,
        43,
        49,
        50,
        51,
        57,
        58,
        61,
        67,
        68,
        71,
        77,
        78,
        81,
        87,
        93,
        99,
        105,
        112,
        114,
        115,
        119,
        126,
        127,
        130,
        139,
        140,
        141,
        149,
        150,
        151,
        159,
        160,
        162,
        168,
        174,
        175,
        177,
        183,
        189,
        190,
        194,
        202,
        203,
        207,
        216,
        217,
        219,
        225,
        231,
        237,
        238,
        240,
        246,
        247,
        249,
        255,
        256,
        258,
        266,
        267,
        269,
        276,
        277,
        281,
        289,
        290,
        292,
        300,
        301,
        303,
        309,
        310,
        312,
        319,
        320,
        322,
        327,
        329,
        330,
        341,
        342,
        343,
        349,
        351,
        353,
        356,
        366,
        367,
        371,
        377,
        378,
        379,
        385,
        386,
        388,
        391,
        397,
        398,
        411,
        417,
        418,
        420,
        423,
        429,
        430,
        442,
        449,
        450,
        452,
        463,
        464,
        466,
        469,
        475,
        476,
        484,
        487
    ],
    "types": {
        "Query": {
            "whoAmi": [
                1
            ],
            "listSessions": [
                4
            ],
            "loginHistory": [
                6
            ],
            "listUser": [
                7,
                {
                    "filters": [
                        11
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        13,
                        "[SortingInputUser!]"
                    ],
                    "category": [
                        16
                    ]
                }
            ],
            "oneUser": [
                8,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsUser": [
                17,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listStorage": [
                18,
                {
                    "filters": [
                        21
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        22,
                        "[SortingInputStorage!]"
                    ],
                    "category": [
                        24
                    ]
                }
            ],
            "oneStorage": [
                19,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "iniGSheetsSyncStorage": [
                25,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "actionsStorage": [
                29,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProduct": [
                30,
                {
                    "filters": [
                        36
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        37,
                        "[SortingInputProduct!]"
                    ],
                    "category": [
                        39
                    ]
                }
            ],
            "oneProduct": [
                40,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProduct": [
                43,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "iniGSheetsSyncProduct": [
                25,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "generateProductArticle": [
                2
            ],
            "listProductBrand": [
                44,
                {
                    "filters": [
                        47
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        48,
                        "[SortingInputProductBrand!]"
                    ],
                    "category": [
                        50
                    ]
                }
            ],
            "oneProductBrand": [
                45,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProductBrand": [
                51,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listCheckPriceMonitor": [
                52,
                {
                    "filters": [
                        55
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        56,
                        "[SortingInputCheckPriceMonitor!]"
                    ],
                    "category": [
                        58
                    ]
                }
            ],
            "oneCheckPriceMonitor": [
                59,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsCheckPriceMonitor": [
                61,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listCheckPriceLink": [
                62,
                {
                    "filters": [
                        65
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        66,
                        "[SortingInputCheckPriceLink!]"
                    ],
                    "category": [
                        68
                    ]
                }
            ],
            "oneCheckPriceLink": [
                69,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsCheckPriceLink": [
                71,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProductCategory": [
                72,
                {
                    "filters": [
                        75
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        76,
                        "[SortingInputProductCategory!]"
                    ],
                    "category": [
                        78
                    ]
                }
            ],
            "oneProductCategory": [
                79,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProductCategory": [
                81,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProductCategoryMovements": [
                82,
                {
                    "filters": [
                        85
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        86,
                        "[SortingInputProductCategoryMovements!]"
                    ],
                    "category_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listProductBrandMovements": [
                88,
                {
                    "filters": [
                        91
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        92,
                        "[SortingInputProductBrandMovements!]"
                    ],
                    "brand_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listProductMovements": [
                94,
                {
                    "filters": [
                        97
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        98,
                        "[SortingInputProductMovements!]"
                    ],
                    "product_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listStorageMovements": [
                100,
                {
                    "filters": [
                        103
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        104,
                        "[SortingInputStorageMovements!]"
                    ],
                    "storage_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listStorageDocuments": [
                106,
                {
                    "filters": [
                        111
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        113,
                        "[SortingInputStorageDocuments!]"
                    ],
                    "category": [
                        115
                    ]
                }
            ],
            "oneStorageDocuments": [
                116,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsStorageDocuments": [
                119,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listStorageShipments": [
                120,
                {
                    "filters": [
                        124
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        125,
                        "[SortingInputStorageShipments!]"
                    ],
                    "category": [
                        127
                    ]
                }
            ],
            "oneStorageShipments": [
                128,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsStorageShipments": [
                130,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "initDeliverStorageShipments": [
                131,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "initPayStorageShipments": [
                133,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listI18nLang": [
                134,
                {
                    "filters": [
                        137
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        138,
                        "[SortingInputI18nLang!]"
                    ],
                    "category": [
                        140
                    ]
                }
            ],
            "oneI18nLang": [
                135,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsI18nLang": [
                141,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "initTranslations": [
                142
            ],
            "listI18nKey": [
                143,
                {
                    "filters": [
                        147
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        148,
                        "[SortingInputI18nKey!]"
                    ],
                    "category": [
                        150
                    ]
                }
            ],
            "oneI18nKey": [
                144,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsI18nKey": [
                151,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "initSmartEditI18nKey": [
                152,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listAccount": [
                154,
                {
                    "filters": [
                        157
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        158,
                        "[SortingInputAccount!]"
                    ],
                    "category": [
                        160
                    ]
                }
            ],
            "oneAccount": [
                161,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "iniGSheetsSyncAccount": [
                25,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "actionsAccount": [
                162,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listAccountMovements": [
                163,
                {
                    "filters": [
                        166
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        167,
                        "[SortingInputAccountMovements!]"
                    ],
                    "account_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listTransactionArticles": [
                169,
                {
                    "filters": [
                        172
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        173,
                        "[SortingInputTransactionArticles!]"
                    ],
                    "category": [
                        175
                    ]
                }
            ],
            "oneTransactionArticles": [
                176,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "iniGSheetsSyncTransactionArticles": [
                25,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "actionsTransactionArticles": [
                177,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listTransactionArticlesMovements": [
                178,
                {
                    "filters": [
                        181
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        182,
                        "[SortingInputTransactionArticlesMovements!]"
                    ],
                    "article_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listTransactions": [
                184,
                {
                    "filters": [
                        187
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        188,
                        "[SortingInputTransactions!]"
                    ],
                    "category": [
                        190
                    ]
                }
            ],
            "oneTransactions": [
                191,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsTransactions": [
                194,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSales": [
                195,
                {
                    "filters": [
                        200
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        201,
                        "[SortingInputSales!]"
                    ],
                    "category": [
                        203
                    ]
                }
            ],
            "oneSales": [
                204,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSales": [
                207,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "initDeliverSales": [
                208,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "initPaySales": [
                210,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listSourceOrders": [
                211,
                {
                    "filters": [
                        214
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        215,
                        "[SortingInputSourceOrders!]"
                    ],
                    "category": [
                        217
                    ]
                }
            ],
            "oneSourceOrders": [
                218,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "iniGSheetsSyncSourceOrders": [
                25,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "actionsSourceOrders": [
                219,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSourceOrdersMovements": [
                220,
                {
                    "filters": [
                        223
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        224,
                        "[SortingInputSourceOrdersMovements!]"
                    ],
                    "sourceOrder_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listDeliveryServicesMovements": [
                226,
                {
                    "filters": [
                        229
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        230,
                        "[SortingInputDeliveryServicesMovements!]"
                    ],
                    "deliveryService_id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "listDeliveryServices": [
                232,
                {
                    "filters": [
                        235
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        236,
                        "[SortingInputDeliveryServices!]"
                    ],
                    "category": [
                        238
                    ]
                }
            ],
            "oneDeliveryServices": [
                239,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "iniGSheetsSyncDeliveryServices": [
                25,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "actionsDeliveryServices": [
                240,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesScroller": [
                241,
                {
                    "filters": [
                        244
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        245,
                        "[SortingInputSitesScroller!]"
                    ],
                    "category": [
                        247
                    ]
                }
            ],
            "oneSitesScroller": [
                248,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSitesScroller": [
                249,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesPages": [
                250,
                {
                    "filters": [
                        253
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        254,
                        "[SortingInputSitesPages!]"
                    ],
                    "category": [
                        256
                    ]
                }
            ],
            "oneSitesPages": [
                257,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSitesPages": [
                258,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "initSmartEditSitesPages": [
                259,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesNews": [
                261,
                {
                    "filters": [
                        264
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        265,
                        "[SortingInputSitesNews!]"
                    ],
                    "category": [
                        267
                    ]
                }
            ],
            "oneSitesNews": [
                268,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSitesNews": [
                269,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesShopCategories": [
                270,
                {
                    "filters": [
                        274
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        275,
                        "[SortingInputSitesShopCategories!]"
                    ],
                    "category": [
                        277
                    ]
                }
            ],
            "oneSitesShopCategories": [
                278,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "initSmartEditSitesShopCategories": [
                279,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "actionsSitesShopCategories": [
                281,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesShopProducts": [
                282,
                {
                    "filters": [
                        287
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        288,
                        "[SortingInputSitesShopProducts!]"
                    ],
                    "category": [
                        290
                    ]
                }
            ],
            "oneSitesShopProducts": [
                291,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSitesShopProducts": [
                292,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "initSmartEditSitesShopProducts": [
                293,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesShopPayment": [
                295,
                {
                    "filters": [
                        298
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        299,
                        "[SortingInputSitesShopPayment!]"
                    ],
                    "category": [
                        301
                    ]
                }
            ],
            "oneSitesShopPayment": [
                302,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSitesShopPayment": [
                303,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listSitesShopDelivery": [
                304,
                {
                    "filters": [
                        307
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        308,
                        "[SortingInputSitesShopDelivery!]"
                    ],
                    "category": [
                        310
                    ]
                }
            ],
            "oneSitesShopDelivery": [
                311,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsSitesShopDelivery": [
                312,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listResolvers": [
                313
            ],
            "listGroups": [
                314,
                {
                    "filters": [
                        317
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        318,
                        "[SortingInputGroups!]"
                    ],
                    "category": [
                        320
                    ]
                }
            ],
            "oneGroups": [
                321,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsGroups": [
                322,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProcurementSupplier": [
                323,
                {
                    "filters": [
                        326
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        328,
                        "[SortingInputProcurementSupplier!]"
                    ],
                    "category": [
                        327
                    ]
                }
            ],
            "oneProcurementSupplier": [
                324,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProcurementSupplier": [
                330,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProcurementRequest": [
                331,
                {
                    "filters": [
                        339
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        340,
                        "[SortingInputProcurementRequest!]"
                    ],
                    "category": [
                        342
                    ]
                }
            ],
            "oneProcurementRequest": [
                332,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProcurementRequest": [
                343,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProcurementContract": [
                344,
                {
                    "filters": [
                        348
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        350,
                        "[SortingInputProcurementContract!]"
                    ],
                    "category": [
                        349
                    ]
                }
            ],
            "oneProcurementContract": [
                352,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProcurementContract": [
                353,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listProcurementDelivery": [
                354,
                {
                    "filters": [
                        364
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        365,
                        "[SortingInputProcurementDelivery!]"
                    ],
                    "category": [
                        367
                    ]
                }
            ],
            "availableRequestItemsForDelivery": [
                368,
                {
                    "request_ids": [
                        9,
                        "[Int!]!"
                    ],
                    "exclude_delivery_id": [
                        9
                    ],
                    "only_available": [
                        3
                    ]
                }
            ],
            "fillProductProcurementDelivery": [
                369,
                {
                    "productId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "oneProcurementDelivery": [
                355,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsProcurementDelivery": [
                371,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listDocumentTemplate": [
                372,
                {
                    "filters": [
                        375
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        376,
                        "[SortingInputDocumentTemplate!]"
                    ],
                    "category": [
                        378
                    ]
                }
            ],
            "oneDocumentTemplate": [
                373,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsDocumentTemplate": [
                379,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listOzonSellerAccounts": [
                380,
                {
                    "filters": [
                        383
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        384,
                        "[SortingInputOzonSellerAccount!]"
                    ],
                    "category": [
                        386
                    ]
                }
            ],
            "oneOzonSellerAccounts": [
                387,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsOzonSellerAccounts": [
                388,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listOzonPostings": [
                389,
                {
                    "filters": [
                        395
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        396,
                        "[SortingInputOzonPosting!]"
                    ],
                    "category": [
                        398
                    ]
                }
            ],
            "oneOzonPostings": [
                399,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "ozonPostingGetSyncRuns": [
                405,
                {
                    "data": [
                        407,
                        "ListOzonPostingGetSyncRunsInput!"
                    ]
                }
            ],
            "ozonPostingGetSyncRunItems": [
                408,
                {
                    "runId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "ozonPostingAutoSyncTasks": [
                409,
                {
                    "data": [
                        410
                    ]
                }
            ],
            "actionsOzonPostings": [
                411,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listWbSellerAccounts": [
                412,
                {
                    "filters": [
                        415
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        416,
                        "[SortingInputWbSellerAccount!]"
                    ],
                    "category": [
                        418
                    ]
                }
            ],
            "oneWbSellerAccounts": [
                419,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsWbSellerAccounts": [
                420,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listWbPostings": [
                421,
                {
                    "filters": [
                        427
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        428,
                        "[SortingInputWbPosting!]"
                    ],
                    "category": [
                        430
                    ]
                }
            ],
            "oneWbPostings": [
                431,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "wbPostingGetSyncRuns": [
                436,
                {
                    "data": [
                        438,
                        "ListWbPostingGetSyncRunsInput!"
                    ]
                }
            ],
            "wbPostingGetSyncRunItems": [
                439,
                {
                    "runId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "wbPostingAutoSyncTasks": [
                440,
                {
                    "data": [
                        441
                    ]
                }
            ],
            "actionsWbPostings": [
                442,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listWbCatalogProducts": [
                443,
                {
                    "filters": [
                        447
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        448,
                        "[SortingInputWbCatalogProduct!]"
                    ],
                    "category": [
                        450
                    ]
                }
            ],
            "oneWbCatalogProducts": [
                451,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsWbCatalogProducts": [
                452,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "wbCatalogSyncRuns": [
                453,
                {
                    "data": [
                        455,
                        "ListWbCatalogSyncRunsInput!"
                    ]
                }
            ],
            "wbCatalogAutoSyncTasks": [
                456,
                {
                    "data": [
                        457
                    ]
                }
            ],
            "listAvitoSellerAccounts": [
                458,
                {
                    "filters": [
                        461
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        462,
                        "[SortingInputAvitoSellerAccount!]"
                    ],
                    "category": [
                        464
                    ]
                }
            ],
            "oneAvitoSellerAccounts": [
                465,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "actionsAvitoSellerAccounts": [
                466,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "listAvitoPostings": [
                467,
                {
                    "filters": [
                        473
                    ],
                    "paging": [
                        12
                    ],
                    "sorting": [
                        474,
                        "[SortingInputAvitoPosting!]"
                    ],
                    "category": [
                        476
                    ]
                }
            ],
            "oneAvitoPostings": [
                477,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "avitoPostingGetSyncRuns": [
                478,
                {
                    "data": [
                        480,
                        "ListAvitoPostingGetSyncRunsInput!"
                    ]
                }
            ],
            "avitoPostingGetSyncRunItems": [
                481,
                {
                    "runId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "avitoPostingAutoSyncTasks": [
                482,
                {
                    "data": [
                        483
                    ]
                }
            ],
            "actionsAvitoPostings": [
                484,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "__typename": [
                2
            ]
        },
        "UserInfo": {
            "id": [
                2
            ],
            "email": [
                2
            ],
            "role": [
                2
            ],
            "permissions": [
                2
            ],
            "displayName": [
                2
            ],
            "photoURL": [
                2
            ],
            "showInterfaceSettings": [
                3
            ],
            "mainCurrency": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "String": {},
        "Boolean": {},
        "Session": {
            "location": [
                2
            ],
            "userAgent": [
                2
            ],
            "platform": [
                2
            ],
            "id": [
                2
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "isCurrent": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "DateTimeISO": {},
        "LoginHistory": {
            "id": [
                2
            ],
            "createdAt": [
                5
            ],
            "platform": [
                2
            ],
            "ip": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ListUser": {
            "items": [
                8
            ],
            "counters": [
                10
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemUser": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "role": [
                2
            ],
            "email": [
                2
            ],
            "displayName": [
                2
            ],
            "photoURL": [
                2
            ],
            "emailVerified": [
                3
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "Int": {},
        "CountersUser": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "banned": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputUser": {
            "role": [
                2
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "PagingInput": {
            "page": [
                9
            ],
            "size": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputUser": {
            "by": [
                14
            ],
            "order": [
                15
            ],
            "__typename": [
                2
            ]
        },
        "By": {},
        "OrderUser": {},
        "CategoriesUser": {},
        "ActionsUser": {},
        "ListStorage": {
            "items": [
                19
            ],
            "counters": [
                20
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemStorage": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "address": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "totalCount": [
                9
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersStorage": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputStorage": {
            "name": [
                2
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputStorage": {
            "by": [
                14
            ],
            "order": [
                23
            ],
            "__typename": [
                2
            ]
        },
        "OrderStorage": {},
        "CategoriesStorage": {},
        "InitSyncDictionaryItems": {
            "items": [
                26
            ],
            "__typename": [
                2
            ]
        },
        "InitSyncDictionaryData": {
            "document": [
                27
            ],
            "syncDocument": [
                28
            ],
            "__typename": [
                2
            ]
        },
        "InitSyncDictionaryDocument": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "isSet": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "InitSyncDictionarySyncDocument": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsStorage": {},
        "ListProduct": {
            "items": [
                31
            ],
            "counters": [
                35
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputProduct": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "rrc": [
                32
            ],
            "oldPrice": [
                32
            ],
            "hsCode": [
                2
            ],
            "width": [
                9
            ],
            "length": [
                9
            ],
            "height": [
                9
            ],
            "weight": [
                32
            ],
            "volume": [
                32
            ],
            "shortDescription": [
                2
            ],
            "barcodes": [
                2
            ],
            "articles": [
                2
            ],
            "productCategoryData": [
                33
            ],
            "productBrandData": [
                34
            ],
            "isSet": [
                3
            ],
            "costPriceRub": [
                32
            ],
            "totalCount": [
                9
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "preview": [
                2
            ],
            "images": [
                2
            ],
            "hasBarcodeAsset": [
                3
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "Float": {},
        "ProductCategoryOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ProductBrandOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProduct": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProduct": {
            "search": [
                2
            ],
            "name": [
                2
            ],
            "productCategory_id": [
                9
            ],
            "productBrand_id": [
                9
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "totalCountFrom": [
                9
            ],
            "totalCountTo": [
                9
            ],
            "isSet": [
                3
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProduct": {
            "by": [
                14
            ],
            "order": [
                38
            ],
            "__typename": [
                2
            ]
        },
        "OrderProduct": {},
        "CategoriesProduct": {},
        "ItemOutputProduct": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "rrc": [
                32
            ],
            "oldPrice": [
                32
            ],
            "hsCode": [
                2
            ],
            "width": [
                9
            ],
            "length": [
                9
            ],
            "height": [
                9
            ],
            "weight": [
                32
            ],
            "volume": [
                32
            ],
            "shortDescription": [
                2
            ],
            "barcodes": [
                2
            ],
            "articles": [
                2
            ],
            "products": [
                41
            ],
            "brand": [
                34
            ],
            "category": [
                33
            ],
            "images": [
                2
            ],
            "isSet": [
                3
            ],
            "costPriceRub": [
                32
            ],
            "totalCount": [
                9
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ProductOutput": {
            "product": [
                42
            ],
            "count": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SimpleProduct": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "preview": [
                2
            ],
            "hsCode": [
                2
            ],
            "costPriceRub": [
                32
            ],
            "rrc": [
                32
            ],
            "articles": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsProduct": {},
        "ListProductBrand": {
            "items": [
                45
            ],
            "counters": [
                46
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemProductBrand": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProductBrand": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProductBrand": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProductBrand": {
            "by": [
                14
            ],
            "order": [
                49
            ],
            "__typename": [
                2
            ]
        },
        "OrderProductBrand": {},
        "CategoriesProductBrand": {},
        "ActionsProductBrand": {},
        "ListCheckPriceMonitor": {
            "items": [
                53
            ],
            "counters": [
                54
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputCheckPriceMonitor": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "checkProductRrc": [
                3
            ],
            "ourPrice": [
                32
            ],
            "status": [
                2
            ],
            "preview": [
                2
            ],
            "minParsedInfo": [
                32
            ],
            "maxParsedInfo": [
                32
            ],
            "succeededLinksCount": [
                32
            ],
            "failedLinksCount": [
                32
            ],
            "totalLinksCount": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "CountersCheckPriceMonitor": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputCheckPriceMonitor": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputCheckPriceMonitor": {
            "by": [
                14
            ],
            "order": [
                57
            ],
            "__typename": [
                2
            ]
        },
        "OrderCheckPriceMonitor": {},
        "CategoriesCheckPriceMonitor": {},
        "ItemOutputCheckPriceMonitor": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "checkProductRrc": [
                3
            ],
            "ourPrice": [
                32
            ],
            "status": [
                2
            ],
            "product": [
                60
            ],
            "__typename": [
                2
            ]
        },
        "OutputProduct": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "preview": [
                2
            ],
            "hsCode": [
                2
            ],
            "costPriceRub": [
                32
            ],
            "rrc": [
                32
            ],
            "articles": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsCheckPriceMonitor": {},
        "ListCheckPriceLink": {
            "items": [
                63
            ],
            "counters": [
                64
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputCheckPriceLink": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "url": [
                2
            ],
            "parserType": [
                2
            ],
            "selector": [
                2
            ],
            "status": [
                2
            ],
            "checkDate": [
                5
            ],
            "checkStatus": [
                2
            ],
            "parsedInfo": [
                2
            ],
            "cardPrice": [
                2
            ],
            "originalPrice": [
                2
            ],
            "isAvailable": [
                3
            ],
            "reviewsCount": [
                2
            ],
            "totalScore": [
                2
            ],
            "sku": [
                2
            ],
            "sellerName": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersCheckPriceLink": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputCheckPriceLink": {
            "name": [
                2
            ],
            "checkPriceMonitor_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputCheckPriceLink": {
            "by": [
                14
            ],
            "order": [
                67
            ],
            "__typename": [
                2
            ]
        },
        "OrderCheckPriceLink": {},
        "CategoriesCheckPriceLink": {},
        "ItemOutputCheckPriceLink": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "url": [
                2
            ],
            "parserType": [
                2
            ],
            "selector": [
                2
            ],
            "status": [
                2
            ],
            "checkDate": [
                5
            ],
            "checkStatus": [
                2
            ],
            "parsedInfo": [
                2
            ],
            "cardPrice": [
                2
            ],
            "originalPrice": [
                2
            ],
            "isAvailable": [
                3
            ],
            "reviewsCount": [
                2
            ],
            "totalScore": [
                2
            ],
            "sku": [
                2
            ],
            "sellerName": [
                2
            ],
            "checkPriceMonitor": [
                59
            ],
            "checkPriceLinkChangesHistory": [
                70
            ],
            "__typename": [
                2
            ]
        },
        "CheckPriceLinkHistory": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "parsedInfo": [
                2
            ],
            "ourPrice": [
                32
            ],
            "cardPrice": [
                2
            ],
            "originalPrice": [
                2
            ],
            "isAvailable": [
                3
            ],
            "reviewsCount": [
                2
            ],
            "totalScore": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsCheckPriceLink": {},
        "ListProductCategory": {
            "items": [
                73
            ],
            "counters": [
                74
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputProductCategory": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "parent": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProductCategory": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProductCategory": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProductCategory": {
            "by": [
                14
            ],
            "order": [
                77
            ],
            "__typename": [
                2
            ]
        },
        "OrderProductCategory": {},
        "CategoriesProductCategory": {},
        "ItemOutputProductCategory": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "parent": [
                80
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CommonProductCategory": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsProductCategory": {},
        "ListProductCategoryMovements": {
            "items": [
                83
            ],
            "counters": [
                84
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ProductCategoryMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "category_id": [
                9
            ],
            "product_id": [
                9
            ],
            "productName": [
                2
            ],
            "set_id": [
                9
            ],
            "setName": [
                2
            ],
            "count": [
                9
            ],
            "storageOut": [
                2
            ],
            "storageIn": [
                2
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProductCategoryMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProductCategoryMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProductCategoryMovements": {
            "by": [
                14
            ],
            "order": [
                87
            ],
            "__typename": [
                2
            ]
        },
        "OrderProductCategoryMovements": {},
        "ListProductBrandMovements": {
            "items": [
                89
            ],
            "counters": [
                90
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ProductBrandMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "brand_id": [
                9
            ],
            "product_id": [
                9
            ],
            "productName": [
                2
            ],
            "set_id": [
                9
            ],
            "setName": [
                2
            ],
            "count": [
                9
            ],
            "storageOut": [
                2
            ],
            "storageIn": [
                2
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProductBrandMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProductBrandMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProductBrandMovements": {
            "by": [
                14
            ],
            "order": [
                93
            ],
            "__typename": [
                2
            ]
        },
        "OrderProductBrandMovements": {},
        "ListProductMovements": {
            "items": [
                95
            ],
            "counters": [
                96
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ProductMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "product_id": [
                9
            ],
            "productName": [
                2
            ],
            "set_id": [
                9
            ],
            "setName": [
                2
            ],
            "count": [
                9
            ],
            "storageOut": [
                2
            ],
            "storageIn": [
                2
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProductMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProductMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProductMovements": {
            "by": [
                14
            ],
            "order": [
                99
            ],
            "__typename": [
                2
            ]
        },
        "OrderProductMovements": {},
        "ListStorageMovements": {
            "items": [
                101
            ],
            "counters": [
                102
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "StorageMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "storage_id": [
                9
            ],
            "product_id": [
                9
            ],
            "productName": [
                2
            ],
            "set_id": [
                9
            ],
            "setName": [
                2
            ],
            "count": [
                9
            ],
            "storageOut": [
                2
            ],
            "storageIn": [
                2
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersStorageMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputStorageMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputStorageMovements": {
            "by": [
                14
            ],
            "order": [
                105
            ],
            "__typename": [
                2
            ]
        },
        "OrderStorageMovements": {},
        "ListStorageDocuments": {
            "items": [
                107
            ],
            "counters": [
                110
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputStorageDocuments": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentType": [
                2
            ],
            "documentNumber": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "comment": [
                2
            ],
            "storageIn": [
                2
            ],
            "storageOut": [
                2
            ],
            "status": [
                2
            ],
            "products": [
                108
            ],
            "__typename": [
                2
            ]
        },
        "StorageDocumentsProductOutput": {
            "product": [
                42
            ],
            "count": [
                9
            ],
            "costPriceRub": [
                32
            ],
            "productSetData": [
                109
            ],
            "__typename": [
                2
            ]
        },
        "StorageDocumentsProductSet": {
            "productName": [
                2
            ],
            "count": [
                9
            ],
            "costPriceRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "CountersStorageDocuments": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputStorageDocuments": {
            "search": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "storageId": [
                9
            ],
            "productId": [
                9
            ],
            "type": [
                112
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "StorageDocumentsType": {},
        "SortingInputStorageDocuments": {
            "by": [
                14
            ],
            "order": [
                114
            ],
            "__typename": [
                2
            ]
        },
        "OrderStorageDocuments": {},
        "CategoriesStorageDocuments": {},
        "ItemOutputStorageDocuments": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentType": [
                2
            ],
            "documentNumber": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "comment": [
                2
            ],
            "storageIn": [
                117
            ],
            "storageOut": [
                117
            ],
            "products": [
                108
            ],
            "linkedDocuments": [
                118
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "StorageOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "LinkedDocuments": {
            "id": [
                9
            ],
            "title": [
                2
            ],
            "type": [
                2
            ],
            "params": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsStorageDocuments": {},
        "ListStorageShipments": {
            "items": [
                121
            ],
            "counters": [
                123
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputStorageShipments": {
            "documentNumber": [
                2
            ],
            "gtd": [
                2
            ],
            "documentDate": [
                5
            ],
            "currency": [
                2
            ],
            "rate": [
                32
            ],
            "comment": [
                2
            ],
            "documentType": [
                2
            ],
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "totalPrice": [
                32
            ],
            "totalPriceRub": [
                32
            ],
            "payStatus": [
                2
            ],
            "deliveryStatus": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "status": [
                2
            ],
            "products": [
                122
            ],
            "__typename": [
                2
            ]
        },
        "StorageShipmentsProductOutput": {
            "product": [
                42
            ],
            "count": [
                9
            ],
            "unitPrice": [
                32
            ],
            "amountPrice": [
                32
            ],
            "totalPrice": [
                32
            ],
            "totalPriceRub": [
                32
            ],
            "unitPriceRub": [
                32
            ],
            "additionalPrice": [
                32
            ],
            "deliveryPrice": [
                32
            ],
            "swiftPrice": [
                32
            ],
            "costPriceRub": [
                32
            ],
            "currency": [
                2
            ],
            "shortDescription": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersStorageShipments": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "working": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputStorageShipments": {
            "search": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "productId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputStorageShipments": {
            "by": [
                14
            ],
            "order": [
                126
            ],
            "__typename": [
                2
            ]
        },
        "OrderStorageShipments": {},
        "CategoriesStorageShipments": {},
        "ItemOutputStorageShipments": {
            "documentNumber": [
                2
            ],
            "gtd": [
                2
            ],
            "documentDate": [
                5
            ],
            "currency": [
                2
            ],
            "rate": [
                32
            ],
            "comment": [
                2
            ],
            "documentType": [
                2
            ],
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "totalPrice": [
                32
            ],
            "totalPriceRub": [
                32
            ],
            "payStatus": [
                2
            ],
            "deliveryStatus": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "status": [
                2
            ],
            "amountPrice": [
                32
            ],
            "additionalPrice": [
                32
            ],
            "additionalComment": [
                2
            ],
            "deliveryPrice": [
                32
            ],
            "swiftPrice": [
                32
            ],
            "products": [
                122
            ],
            "linkedDocuments": [
                129
            ],
            "__typename": [
                2
            ]
        },
        "LinkedDocumentsStorageShipments": {
            "id": [
                9
            ],
            "title": [
                2
            ],
            "type": [
                2
            ],
            "params": [
                2
            ],
            "comment": [
                2
            ],
            "amount": [
                2
            ],
            "accountIn_id": [
                9
            ],
            "accountOut_id": [
                9
            ],
            "currency": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsStorageShipments": {},
        "InitDeliverStorageShipments": {
            "products": [
                132
            ],
            "__typename": [
                2
            ]
        },
        "DeliverProducts": {
            "product": [
                42
            ],
            "totalCount": [
                9
            ],
            "count": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "InitPayStorageShipments": {
            "completedAmount": [
                32
            ],
            "totalPriceRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ListI18nLang": {
            "items": [
                135
            ],
            "counters": [
                136
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemI18nLang": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersI18nLang": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputI18nLang": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputI18nLang": {
            "by": [
                14
            ],
            "order": [
                139
            ],
            "__typename": [
                2
            ]
        },
        "OrderI18nLang": {},
        "CategoriesI18nLang": {},
        "ActionsI18nLang": {},
        "InitTranslations": {
            "id": [
                9
            ],
            "key": [
                2
            ],
            "lang": [
                2
            ],
            "translation": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ListI18nKey": {
            "items": [
                144
            ],
            "counters": [
                146
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemI18nKey": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "key": [
                2
            ],
            "originalTranslation": [
                2
            ],
            "i18n": [
                145
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "I18nLangOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "translation": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersI18nKey": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputI18nKey": {
            "key": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputI18nKey": {
            "by": [
                14
            ],
            "order": [
                149
            ],
            "__typename": [
                2
            ]
        },
        "OrderI18nKey": {},
        "CategoriesI18nKey": {},
        "ActionsI18nKey": {},
        "InitSmartEditI18nKey": {
            "keys": [
                144
            ],
            "baseData": [
                153
            ],
            "baseJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "InitSmartEditItemI18nKey": {
            "id": [
                9
            ],
            "key": [
                2
            ],
            "originalTranslation": [
                2
            ],
            "i18n": [
                145
            ],
            "__typename": [
                2
            ]
        },
        "ListAccount": {
            "items": [
                155
            ],
            "counters": [
                156
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "code": [
                2
            ],
            "currency": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "balance": [
                32
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersAccount": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputAccount": {
            "name": [
                2
            ],
            "currency": [
                2
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputAccount": {
            "by": [
                14
            ],
            "order": [
                159
            ],
            "__typename": [
                2
            ]
        },
        "OrderAccount": {},
        "CategoriesAccount": {},
        "ItemOutputAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "code": [
                2
            ],
            "currency": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "balance": [
                32
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsAccount": {},
        "ListAccountMovements": {
            "items": [
                164
            ],
            "counters": [
                165
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "AccountMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "account_id": [
                9
            ],
            "amount": [
                32
            ],
            "currency": [
                2
            ],
            "accountIn": [
                2
            ],
            "accountOut": [
                2
            ],
            "transactionArticles": [
                2
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersAccountMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputAccountMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputAccountMovements": {
            "by": [
                14
            ],
            "order": [
                168
            ],
            "__typename": [
                2
            ]
        },
        "OrderAccountMovements": {},
        "ListTransactionArticles": {
            "items": [
                170
            ],
            "counters": [
                171
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputTransactionArticles": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "code": [
                2
            ],
            "fixedPercent": [
                32
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersTransactionArticles": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputTransactionArticles": {
            "name": [
                2
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputTransactionArticles": {
            "by": [
                14
            ],
            "order": [
                174
            ],
            "__typename": [
                2
            ]
        },
        "OrderTransactionArticles": {},
        "CategoriesTransactionArticles": {},
        "ItemOutputTransactionArticles": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "code": [
                2
            ],
            "fixedPercent": [
                32
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsTransactionArticles": {},
        "ListTransactionArticlesMovements": {
            "items": [
                179
            ],
            "counters": [
                180
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "TransactionArticlesMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "article_id": [
                9
            ],
            "amount": [
                32
            ],
            "currency": [
                2
            ],
            "accountIn": [
                2
            ],
            "accountOut": [
                2
            ],
            "transactionArticles": [
                2
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersTransactionArticlesMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputTransactionArticlesMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputTransactionArticlesMovements": {
            "by": [
                14
            ],
            "order": [
                183
            ],
            "__typename": [
                2
            ]
        },
        "OrderTransactionArticlesMovements": {},
        "ListTransactions": {
            "items": [
                185
            ],
            "counters": [
                186
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputTransactions": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentNumber": [
                2
            ],
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "currency": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "documentType": [
                2
            ],
            "transactionArticles": [
                2
            ],
            "accountIn": [
                2
            ],
            "accountOut": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersTransactions": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputTransactions": {
            "search": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "amountFrom": [
                32
            ],
            "amountTo": [
                32
            ],
            "transactionArticlesId": [
                9
            ],
            "accountId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputTransactions": {
            "by": [
                14
            ],
            "order": [
                189
            ],
            "__typename": [
                2
            ]
        },
        "OrderTransactions": {},
        "CategoriesTransactions": {},
        "ItemOutputTransactions": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentNumber": [
                2
            ],
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "currency": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "documentType": [
                2
            ],
            "transactionArticles": [
                192
            ],
            "accountIn": [
                193
            ],
            "accountOut": [
                193
            ],
            "linkedDocuments": [
                118
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "TransactionArticlesOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "AccountOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsTransactions": {},
        "ListSales": {
            "items": [
                196
            ],
            "counters": [
                199
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSales": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "comment": [
                2
            ],
            "deliveryType_id": [
                9
            ],
            "buyerPhone": [
                2
            ],
            "buyerName": [
                2
            ],
            "buyerEmail": [
                2
            ],
            "sourceOrderNumber": [
                2
            ],
            "totalPriceRub": [
                32
            ],
            "costPriceRub": [
                32
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "profitRub": [
                32
            ],
            "discountRub": [
                32
            ],
            "totalDiscountPriceRub": [
                32
            ],
            "fullPriceRub": [
                32
            ],
            "payStatus": [
                2
            ],
            "deliveryStatus": [
                2
            ],
            "deliveryServiceStatus": [
                2
            ],
            "sourceOrder": [
                197
            ],
            "status": [
                2
            ],
            "products": [
                198
            ],
            "__typename": [
                2
            ]
        },
        "SourceOrdersOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SalesProductOutput": {
            "product": [
                42
            ],
            "count": [
                9
            ],
            "totalPriceRub": [
                32
            ],
            "costPriceRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "CountersSales": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "return": [
                9
            ],
            "inactive": [
                9
            ],
            "working": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSales": {
            "search": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "productId": [
                9
            ],
            "paymentAccount_id": [
                9
            ],
            "deliveryFromStorage_id": [
                9
            ],
            "sourceOrder_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSales": {
            "by": [
                14
            ],
            "order": [
                202
            ],
            "__typename": [
                2
            ]
        },
        "OrderSales": {},
        "CategoriesSales": {},
        "ItemOutputSales": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "comment": [
                2
            ],
            "deliveryType_id": [
                9
            ],
            "buyerPhone": [
                2
            ],
            "buyerName": [
                2
            ],
            "buyerEmail": [
                2
            ],
            "sourceOrderNumber": [
                2
            ],
            "totalPriceRub": [
                32
            ],
            "costPriceRub": [
                32
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "profitRub": [
                32
            ],
            "discountRub": [
                32
            ],
            "totalDiscountPriceRub": [
                32
            ],
            "fullPriceRub": [
                32
            ],
            "payStatus": [
                2
            ],
            "deliveryStatus": [
                2
            ],
            "deliveryServiceStatus": [
                2
            ],
            "sourceOrder": [
                197
            ],
            "status": [
                2
            ],
            "products": [
                198
            ],
            "linkedDocuments": [
                205
            ],
            "paymentAccount": [
                193
            ],
            "deliveryFromStorage": [
                117
            ],
            "withSPB": [
                3
            ],
            "withOnline": [
                3
            ],
            "withReceipt": [
                3
            ],
            "deliveryService": [
                206
            ],
            "deliveryNumber": [
                2
            ],
            "deliveryCity": [
                2
            ],
            "deliveryAddress": [
                2
            ],
            "deliveryPriceRub": [
                32
            ],
            "deliveryFromAccount": [
                193
            ],
            "includeDeliveryPriceRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "LinkedDocumentsSales": {
            "id": [
                9
            ],
            "title": [
                2
            ],
            "type": [
                2
            ],
            "params": [
                2
            ],
            "comment": [
                2
            ],
            "amount": [
                2
            ],
            "accountIn_id": [
                9
            ],
            "accountOut_id": [
                9
            ],
            "currency": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "DeliveryServicesOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSales": {},
        "InitDeliverSales": {
            "products": [
                209
            ],
            "deliveryFromStorage_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "DeliverSalesProducts": {
            "product": [
                42
            ],
            "totalCount": [
                9
            ],
            "count": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "InitPaySales": {
            "completedAmount": [
                32
            ],
            "totalDiscountPriceRub": [
                32
            ],
            "paymentAccount_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListSourceOrders": {
            "items": [
                212
            ],
            "counters": [
                213
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSourceOrders": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSourceOrders": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSourceOrders": {
            "name": [
                2
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSourceOrders": {
            "by": [
                14
            ],
            "order": [
                216
            ],
            "__typename": [
                2
            ]
        },
        "OrderSourceOrders": {},
        "CategoriesSourceOrders": {},
        "ItemOutputSourceOrders": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSourceOrders": {},
        "ListSourceOrdersMovements": {
            "items": [
                221
            ],
            "counters": [
                222
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SourceOrdersMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "sourceOrder_id": [
                9
            ],
            "product_id": [
                9
            ],
            "productName": [
                2
            ],
            "count": [
                9
            ],
            "totalPriceRub": [
                32
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSourceOrdersMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSourceOrdersMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSourceOrdersMovements": {
            "by": [
                14
            ],
            "order": [
                225
            ],
            "__typename": [
                2
            ]
        },
        "OrderSourceOrdersMovements": {},
        "ListDeliveryServicesMovements": {
            "items": [
                227
            ],
            "counters": [
                228
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "DeliveryServicesMovementItem": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "date": [
                5
            ],
            "deliveryService_id": [
                9
            ],
            "product_id": [
                9
            ],
            "productName": [
                2
            ],
            "count": [
                9
            ],
            "totalPriceRub": [
                32
            ],
            "comment": [
                2
            ],
            "entity": [
                2
            ],
            "documentId": [
                9
            ],
            "documentNumber": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersDeliveryServicesMovements": {
            "all": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputDeliveryServicesMovements": {
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputDeliveryServicesMovements": {
            "by": [
                14
            ],
            "order": [
                231
            ],
            "__typename": [
                2
            ]
        },
        "OrderDeliveryServicesMovements": {},
        "ListDeliveryServices": {
            "items": [
                233
            ],
            "counters": [
                234
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputDeliveryServices": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersDeliveryServices": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputDeliveryServices": {
            "name": [
                2
            ],
            "withSync": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputDeliveryServices": {
            "by": [
                14
            ],
            "order": [
                237
            ],
            "__typename": [
                2
            ]
        },
        "OrderDeliveryServices": {},
        "CategoriesDeliveryServices": {},
        "ItemOutputDeliveryServices": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "gSheetsSyncStatus": [
                2
            ],
            "gSheetsSyncName": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsDeliveryServices": {},
        "ListSitesScroller": {
            "items": [
                242
            ],
            "counters": [
                243
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesScroller": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "hasShop": [
                3
            ],
            "hasNews": [
                3
            ],
            "shopSlug": [
                2
            ],
            "shopTitle": [
                2
            ],
            "newsSlug": [
                2
            ],
            "newsTitle": [
                2
            ],
            "cdnUrl": [
                2
            ],
            "shopCategorySections": [
                2
            ],
            "shopProductSections": [
                2
            ],
            "ftpHost": [
                2
            ],
            "ftpUser": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesScroller": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesScroller": {
            "name": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesScroller": {
            "by": [
                14
            ],
            "order": [
                246
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesScroller": {},
        "CategoriesSitesScroller": {},
        "ItemOutputSitesScroller": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "hasShop": [
                3
            ],
            "hasNews": [
                3
            ],
            "shopSlug": [
                2
            ],
            "shopTitle": [
                2
            ],
            "newsSlug": [
                2
            ],
            "newsTitle": [
                2
            ],
            "cdnUrl": [
                2
            ],
            "shopCategorySections": [
                2
            ],
            "shopProductSections": [
                2
            ],
            "ftpHost": [
                2
            ],
            "ftpUser": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesScroller": {},
        "ListSitesPages": {
            "items": [
                251
            ],
            "counters": [
                252
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesPages": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "content": [
                2
            ],
            "links": [
                2
            ],
            "meta": [
                2
            ],
            "sections": [
                2
            ],
            "documentType": [
                2
            ],
            "status": [
                2
            ],
            "linkedDocuments": [
                118
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesPages": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesPages": {
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesPages": {
            "by": [
                14
            ],
            "order": [
                255
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesPages": {},
        "CategoriesSitesPages": {},
        "ItemOutputSitesPages": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "content": [
                2
            ],
            "links": [
                2
            ],
            "meta": [
                2
            ],
            "sections": [
                2
            ],
            "documentType": [
                2
            ],
            "status": [
                2
            ],
            "linkedDocuments": [
                118
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesPages": {},
        "InitSmartEditSitesPages": {
            "pages": [
                257
            ],
            "baseData": [
                260
            ],
            "baseJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "InitSmartEditPageItem": {
            "id": [
                9
            ],
            "title": [
                2
            ],
            "slug": [
                2
            ],
            "meta": [
                2
            ],
            "links": [
                2
            ],
            "sections": [
                2
            ],
            "documentType": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ListSitesNews": {
            "items": [
                262
            ],
            "counters": [
                263
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesNews": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "content": [
                2
            ],
            "publishedAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesNews": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesNews": {
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesNews": {
            "by": [
                14
            ],
            "order": [
                266
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesNews": {},
        "CategoriesSitesNews": {},
        "ItemOutputSitesNews": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "content": [
                2
            ],
            "publishedAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesNews": {},
        "ListSitesShopCategories": {
            "items": [
                271
            ],
            "counters": [
                273
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesShopCategories": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "parent": [
                272
            ],
            "image": [
                2
            ],
            "icon": [
                2
            ],
            "parent_id": [
                9
            ],
            "hasChildren": [
                3
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SitesShopCategoriesOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "slug": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesShopCategories": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesShopCategories": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "parent_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesShopCategories": {
            "by": [
                14
            ],
            "order": [
                276
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesShopCategories": {},
        "CategoriesSitesShopCategories": {},
        "ItemOutputSitesShopCategories": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "parent": [
                272
            ],
            "image": [
                2
            ],
            "icon": [
                2
            ],
            "parent_id": [
                9
            ],
            "hasChildren": [
                3
            ],
            "status": [
                2
            ],
            "linkedDocuments": [
                118
            ],
            "__typename": [
                2
            ]
        },
        "InitSmartEditSitesShopCategories": {
            "categories": [
                278
            ],
            "baseData": [
                280
            ],
            "baseJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "InitSmartEditCategoryItem": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "parentId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesShopCategories": {},
        "ListSitesShopProducts": {
            "items": [
                283
            ],
            "counters": [
                286
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesShopProducts": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "shortDescription": [
                2
            ],
            "images": [
                2
            ],
            "price": [
                32
            ],
            "product": [
                284
            ],
            "category": [
                272
            ],
            "articles": [
                2
            ],
            "url": [
                2
            ],
            "status": [
                2
            ],
            "linkedDocuments": [
                118
            ],
            "categoryName": [
                2
            ],
            "preview": [
                2
            ],
            "inStock": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ExtendSimpleProductForSitesShopProducts": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "preview": [
                2
            ],
            "hsCode": [
                2
            ],
            "costPriceRub": [
                32
            ],
            "rrc": [
                32
            ],
            "articles": [
                2
            ],
            "images": [
                2
            ],
            "count": [
                9
            ],
            "productSetItems": [
                285
            ],
            "inStock": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ProductSetItem": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "count": [
                9
            ],
            "totalCount": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesShopProducts": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesShopProducts": {
            "name": [
                2
            ],
            "articles": [
                2
            ],
            "categoryName": [
                2
            ],
            "slug": [
                2
            ],
            "site_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesShopProducts": {
            "by": [
                14
            ],
            "order": [
                289
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesShopProducts": {},
        "CategoriesSitesShopProducts": {},
        "ItemOutputSitesShopProducts": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "shortDescription": [
                2
            ],
            "images": [
                2
            ],
            "price": [
                32
            ],
            "product": [
                284
            ],
            "category": [
                272
            ],
            "articles": [
                2
            ],
            "url": [
                2
            ],
            "status": [
                2
            ],
            "linkedDocuments": [
                118
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesShopProducts": {},
        "InitSmartEditSitesShopProducts": {
            "products": [
                294
            ],
            "baseData": [
                294
            ],
            "baseJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "InitSmartEditProductItem": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "shortDescription": [
                2
            ],
            "price": [
                32
            ],
            "product_id": [
                9
            ],
            "site_id": [
                9
            ],
            "category_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListSitesShopPayment": {
            "items": [
                296
            ],
            "counters": [
                297
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesShopPayment": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "description": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesShopPayment": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesShopPayment": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesShopPayment": {
            "by": [
                14
            ],
            "order": [
                300
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesShopPayment": {},
        "CategoriesSitesShopPayment": {},
        "ItemOutputSitesShopPayment": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "description": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesShopPayment": {},
        "ListSitesShopDelivery": {
            "items": [
                305
            ],
            "counters": [
                306
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputSitesShopDelivery": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "description": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersSitesShopDelivery": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputSitesShopDelivery": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputSitesShopDelivery": {
            "by": [
                14
            ],
            "order": [
                309
            ],
            "__typename": [
                2
            ]
        },
        "OrderSitesShopDelivery": {},
        "CategoriesSitesShopDelivery": {},
        "ItemOutputSitesShopDelivery": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "description": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsSitesShopDelivery": {},
        "ResolverItemOutput": {
            "key": [
                2
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ListGroups": {
            "items": [
                315
            ],
            "counters": [
                316
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputGroups": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "role": [
                2
            ],
            "description": [
                2
            ],
            "permissions": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersGroups": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputGroups": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputGroups": {
            "by": [
                14
            ],
            "order": [
                319
            ],
            "__typename": [
                2
            ]
        },
        "OrderGroups": {},
        "CategoriesGroups": {},
        "ItemOutputGroups": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "role": [
                2
            ],
            "description": [
                2
            ],
            "permissions": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsGroups": {},
        "ListProcurementSupplier": {
            "items": [
                324
            ],
            "counters": [
                325
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemProcurementSupplier": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "nameNative": [
                2
            ],
            "nameEnglish": [
                2
            ],
            "nameRussian": [
                2
            ],
            "countryCode": [
                2
            ],
            "address": [
                2
            ],
            "addressNative": [
                2
            ],
            "addressEnglish": [
                2
            ],
            "addressRussian": [
                2
            ],
            "description": [
                2
            ],
            "contactName": [
                2
            ],
            "contactNameNative": [
                2
            ],
            "contactNameEnglish": [
                2
            ],
            "contactNameRussian": [
                2
            ],
            "phone": [
                2
            ],
            "email": [
                2
            ],
            "site": [
                2
            ],
            "taxIdentifier": [
                2
            ],
            "kpp": [
                2
            ],
            "ogrn": [
                2
            ],
            "bankAccountNumber": [
                2
            ],
            "bankCorrAccountNumber": [
                2
            ],
            "bankBic": [
                2
            ],
            "bankCnapsCode": [
                2
            ],
            "bankSwiftCode": [
                2
            ],
            "bankName": [
                2
            ],
            "bankAddress": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProcurementSupplier": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProcurementSupplier": {
            "search": [
                2
            ],
            "name": [
                2
            ],
            "category": [
                327
            ],
            "countryCode": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CategoriesProcurementSupplier": {},
        "SortingInputProcurementSupplier": {
            "by": [
                14
            ],
            "order": [
                329
            ],
            "__typename": [
                2
            ]
        },
        "OrderProcurementSupplier": {},
        "ActionsProcurementSupplier": {},
        "ListProcurementRequest": {
            "items": [
                332
            ],
            "counters": [
                338
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementRequest": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "comment": [
                2
            ],
            "importantNote": [
                2
            ],
            "currency": [
                2
            ],
            "tradeTerms": [
                2
            ],
            "request_status": [
                2
            ],
            "totalAmount": [
                32
            ],
            "status": [
                2
            ],
            "supplier": [
                333
            ],
            "buyer": [
                333
            ],
            "contract": [
                334
            ],
            "items": [
                335
            ],
            "expenses": [
                337
            ],
            "expensesComment": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ProcurementSupplierOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "nameNative": [
                2
            ],
            "nameEnglish": [
                2
            ],
            "nameRussian": [
                2
            ],
            "countryCode": [
                2
            ],
            "address": [
                2
            ],
            "addressNative": [
                2
            ],
            "addressEnglish": [
                2
            ],
            "addressRussian": [
                2
            ],
            "contactName": [
                2
            ],
            "contactNameNative": [
                2
            ],
            "contactNameEnglish": [
                2
            ],
            "contactNameRussian": [
                2
            ],
            "phone": [
                2
            ],
            "email": [
                2
            ],
            "site": [
                2
            ],
            "bankAccountNumber": [
                2
            ],
            "bankCorrAccountNumber": [
                2
            ],
            "bankBic": [
                2
            ],
            "bankCnapsCode": [
                2
            ],
            "bankSwiftCode": [
                2
            ],
            "bankName": [
                2
            ],
            "bankAddress": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ProcurementContractOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "importantNote": [
                2
            ],
            "currency": [
                2
            ],
            "contract_number": [
                2
            ],
            "contract_date": [
                5
            ],
            "contract_amount": [
                32
            ],
            "contract_end_date": [
                5
            ],
            "without_number": [
                3
            ],
            "without_amount": [
                3
            ],
            "supplier": [
                333
            ],
            "buyer": [
                333
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementRequestItem": {
            "id": [
                9
            ],
            "productName": [
                2
            ],
            "description": [
                2
            ],
            "quantity": [
                32
            ],
            "price": [
                32
            ],
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "sortOrder": [
                9
            ],
            "availableQuantity": [
                32
            ],
            "images": [
                2
            ],
            "imageSlotId": [
                2
            ],
            "product": [
                336
            ],
            "costPrice": [
                32
            ],
            "additionalCostPrice": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ProductRefOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "preview": [
                2
            ],
            "shortDescription": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementRequestExpense": {
            "id": [
                9
            ],
            "amount": [
                32
            ],
            "rate": [
                32
            ],
            "amountInMainCurrency": [
                32
            ],
            "comment": [
                2
            ],
            "isPaymentForInvoice": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "CountersProcurementRequest": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProcurementRequest": {
            "search": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "contract_id": [
                9
            ],
            "productId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProcurementRequest": {
            "by": [
                14
            ],
            "order": [
                341
            ],
            "__typename": [
                2
            ]
        },
        "OrderProcurementRequest": {},
        "CategoriesProcurementRequest": {},
        "ActionsProcurementRequest": {},
        "ListProcurementContract": {
            "items": [
                345
            ],
            "counters": [
                347
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputProcurementContract": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "importantNote": [
                2
            ],
            "currency": [
                2
            ],
            "contract_number": [
                2
            ],
            "contract_date": [
                5
            ],
            "contract_amount": [
                32
            ],
            "contract_end_date": [
                5
            ],
            "without_number": [
                3
            ],
            "without_amount": [
                3
            ],
            "status": [
                2
            ],
            "supplier_id": [
                9
            ],
            "buyer_id": [
                9
            ],
            "supplier": [
                333
            ],
            "buyer": [
                333
            ],
            "requests": [
                346
            ],
            "__typename": [
                2
            ]
        },
        "ProcurementRequestOutput": {
            "id": [
                9
            ],
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "currency": [
                2
            ],
            "tradeTerms": [
                2
            ],
            "totalAmount": [
                32
            ],
            "comment": [
                2
            ],
            "request_status": [
                2
            ],
            "importantNote": [
                2
            ],
            "supplier": [
                333
            ],
            "buyer": [
                333
            ],
            "items": [
                335
            ],
            "__typename": [
                2
            ]
        },
        "CountersProcurementContract": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProcurementContract": {
            "name": [
                2
            ],
            "category": [
                349
            ],
            "__typename": [
                2
            ]
        },
        "CategoriesProcurementContract": {},
        "SortingInputProcurementContract": {
            "by": [
                14
            ],
            "order": [
                351
            ],
            "__typename": [
                2
            ]
        },
        "OrderProcurementContract": {},
        "ItemOutputProcurementContract": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "importantNote": [
                2
            ],
            "currency": [
                2
            ],
            "contract_number": [
                2
            ],
            "contract_date": [
                5
            ],
            "contract_amount": [
                32
            ],
            "contract_end_date": [
                5
            ],
            "without_number": [
                3
            ],
            "without_amount": [
                3
            ],
            "status": [
                2
            ],
            "supplier_id": [
                9
            ],
            "buyer_id": [
                9
            ],
            "supplier": [
                333
            ],
            "buyer": [
                333
            ],
            "requests": [
                346
            ],
            "__typename": [
                2
            ]
        },
        "ActionsProcurementContract": {},
        "ListProcurementDelivery": {
            "items": [
                355
            ],
            "counters": [
                363
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementDelivery": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "comment": [
                2
            ],
            "tradeTerms": [
                2
            ],
            "gtd": [
                2
            ],
            "shipmentData": [
                356
            ],
            "status": [
                2
            ],
            "deliveryStatus": [
                2
            ],
            "contract_id": [
                9
            ],
            "contract": [
                334
            ],
            "requests": [
                346
            ],
            "items": [
                357
            ],
            "boxes": [
                360
            ],
            "expenses": [
                362
            ],
            "expensesComment": [
                2
            ],
            "totalQuantity": [
                9
            ],
            "totalProductQuantity": [
                9
            ],
            "totalVolume": [
                32
            ],
            "totalNetWeightKg": [
                32
            ],
            "totalGrossWeightKg": [
                32
            ],
            "totalAmount": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "JSONObject": {},
        "ItemOutputProcurementDeliveryItem": {
            "id": [
                9
            ],
            "kitName": [
                2
            ],
            "hsCode": [
                2
            ],
            "countryOfOrigin": [
                2
            ],
            "description": [
                2
            ],
            "quantity": [
                32
            ],
            "price": [
                32
            ],
            "amount": [
                32
            ],
            "netWeightKg": [
                32
            ],
            "grossWeightKg": [
                32
            ],
            "sortOrder": [
                9
            ],
            "product": [
                358
            ],
            "components": [
                359
            ],
            "__typename": [
                2
            ]
        },
        "ProductRefOutputProcurementDeliveryItem": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "preview": [
                2
            ],
            "shortDescription": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementDeliveryItemComponent": {
            "id": [
                9
            ],
            "procurementRequestItemId": [
                9
            ],
            "quantity": [
                32
            ],
            "requestItem": [
                335
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementDeliveryBox": {
            "id": [
                9
            ],
            "quantity": [
                9
            ],
            "hsCode": [
                2
            ],
            "countryOfOrigin": [
                2
            ],
            "description": [
                2
            ],
            "qtyPcs": [
                32
            ],
            "pricePerPcs": [
                32
            ],
            "amount": [
                32
            ],
            "weightPerBoxKg": [
                32
            ],
            "netWeightKg": [
                32
            ],
            "grossWeightKg": [
                32
            ],
            "lengthCm": [
                32
            ],
            "widthCm": [
                32
            ],
            "heightCm": [
                32
            ],
            "cubicMeterM3": [
                32
            ],
            "items": [
                361
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementDeliveryBoxItem": {
            "id": [
                9
            ],
            "procurementDeliveryItemId": [
                9
            ],
            "quantity": [
                32
            ],
            "netWeightKg": [
                32
            ],
            "grossWeightKg": [
                32
            ],
            "deliveryItem": [
                357
            ],
            "__typename": [
                2
            ]
        },
        "ItemOutputProcurementDeliveryExpense": {
            "id": [
                9
            ],
            "amount": [
                32
            ],
            "rate": [
                32
            ],
            "amountInMainCurrency": [
                32
            ],
            "comment": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersProcurementDelivery": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputProcurementDelivery": {
            "name": [
                2
            ],
            "contract_id": [
                9
            ],
            "request_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputProcurementDelivery": {
            "by": [
                14
            ],
            "order": [
                366
            ],
            "__typename": [
                2
            ]
        },
        "OrderProcurementDelivery": {},
        "CategoriesProcurementDelivery": {},
        "AvailableRequestItemForDeliveryOutput": {
            "requestItem": [
                335
            ],
            "availableQuantity": [
                32
            ],
            "requestId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FillProductDataProcurementDelivery": {
            "hsCode": [
                2
            ],
            "countryOfOrigin": [
                2
            ],
            "kitName": [
                2
            ],
            "description": [
                2
            ],
            "quantity": [
                32
            ],
            "price": [
                32
            ],
            "amount": [
                32
            ],
            "products": [
                370
            ],
            "__typename": [
                2
            ]
        },
        "FillProductComponentProcurementDelivery": {
            "procurementRequestItemId": [
                9
            ],
            "quantity": [
                32
            ],
            "requestItem": [
                335
            ],
            "__typename": [
                2
            ]
        },
        "ActionsProcurementDelivery": {},
        "ListDocumentTemplate": {
            "items": [
                373
            ],
            "counters": [
                374
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemDocumentTemplate": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "description": [
                2
            ],
            "assetCode": [
                2
            ],
            "templateType": [
                2
            ],
            "pageOrientation": [
                2
            ],
            "templateHtml": [
                2
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersDocumentTemplate": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputDocumentTemplate": {
            "name": [
                2
            ],
            "assetCode": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputDocumentTemplate": {
            "by": [
                14
            ],
            "order": [
                377
            ],
            "__typename": [
                2
            ]
        },
        "OrderDocumentTemplate": {},
        "CategoriesDocumentTemplate": {},
        "ActionsDocumentTemplate": {},
        "ListOzonSellerAccount": {
            "items": [
                381
            ],
            "counters": [
                382
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputOzonSellerAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "hasApiKey": [
                3
            ],
            "lastSyncAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersOzonSellerAccount": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputOzonSellerAccount": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputOzonSellerAccount": {
            "by": [
                14
            ],
            "order": [
                385
            ],
            "__typename": [
                2
            ]
        },
        "OrderOzonSellerAccount": {},
        "CategoriesOzonSellerAccount": {},
        "ItemOutputOzonSellerAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "hasApiKey": [
                3
            ],
            "lastSyncAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsOzonSellerAccount": {},
        "ListOzonPosting": {
            "items": [
                390
            ],
            "counters": [
                394
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputOzonPosting": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "postingNumber": [
                2
            ],
            "orderId": [
                2
            ],
            "orderNumber": [
                2
            ],
            "scheme": [
                391
            ],
            "status": [
                2
            ],
            "substatus": [
                2
            ],
            "inProcessAt": [
                5
            ],
            "shipmentDate": [
                5
            ],
            "warehouseId": [
                2
            ],
            "warehouseName": [
                2
            ],
            "deliveryMethodId": [
                2
            ],
            "deliveryMethodName": [
                2
            ],
            "isExpress": [
                3
            ],
            "syncedAt": [
                5
            ],
            "account": [
                392
            ],
            "products": [
                393
            ],
            "taxBaseFromCustomerPrice": [
                32
            ],
            "orderProfitRub": [
                32
            ],
            "taxBaseCustomerCurrencyCode": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SchemeOzonPosting": {},
        "OzonSellerAccountShortOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingProductOutput": {
            "id": [
                9
            ],
            "offerId": [
                2
            ],
            "sku": [
                2
            ],
            "productId": [
                2
            ],
            "name": [
                2
            ],
            "quantity": [
                9
            ],
            "price": [
                2
            ],
            "oldPrice": [
                2
            ],
            "currencyCode": [
                2
            ],
            "customerPrice": [
                32
            ],
            "customerCurrencyCode": [
                2
            ],
            "commissionAmount": [
                32
            ],
            "commissionPercent": [
                9
            ],
            "payout": [
                32
            ],
            "totalDiscountValue": [
                32
            ],
            "totalDiscountPercent": [
                32
            ],
            "imageUrl": [
                2
            ],
            "previewUrl": [
                2
            ],
            "product": [
                42
            ],
            "snapshotCostPriceRub": [
                32
            ],
            "snapshotCostProductId": [
                9
            ],
            "snapshotCostPricedAt": [
                5
            ],
            "effectiveUnitCostRub": [
                32
            ],
            "lineCostRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "CountersOzonPosting": {
            "all": [
                9
            ],
            "awaiting": [
                9
            ],
            "delivering": [
                9
            ],
            "delivered": [
                9
            ],
            "cancelled": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputOzonPosting": {
            "search": [
                2
            ],
            "ozonSellerAccountId": [
                9
            ],
            "status": [
                2
            ],
            "scheme": [
                391
            ],
            "warehouseId": [
                2
            ],
            "productId": [
                9
            ],
            "productName": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputOzonPosting": {
            "by": [
                14
            ],
            "order": [
                397
            ],
            "__typename": [
                2
            ]
        },
        "OrderOzonPosting": {},
        "CategoriesOzonPosting": {},
        "ItemOutputOzonPosting": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "postingNumber": [
                2
            ],
            "orderId": [
                2
            ],
            "orderNumber": [
                2
            ],
            "scheme": [
                391
            ],
            "status": [
                2
            ],
            "substatus": [
                2
            ],
            "inProcessAt": [
                5
            ],
            "shipmentDate": [
                5
            ],
            "warehouseId": [
                2
            ],
            "warehouseName": [
                2
            ],
            "deliveryMethodId": [
                2
            ],
            "deliveryMethodName": [
                2
            ],
            "isExpress": [
                3
            ],
            "syncedAt": [
                5
            ],
            "account": [
                392
            ],
            "products": [
                393
            ],
            "accruals": [
                400
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingAccrualsOutput": {
            "operations": [
                401
            ],
            "totals": [
                402
            ],
            "financialDataFromGet": [
                403
            ],
            "getPayloadJson": [
                2
            ],
            "totalFromOperations": [
                32
            ],
            "orderCostRubTotal": [
                32
            ],
            "orderProfitRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "OzonAccrualOperationOutput": {
            "operationId": [
                2
            ],
            "operationType": [
                2
            ],
            "operationDate": [
                2
            ],
            "operationTypeName": [
                2
            ],
            "amount": [
                32
            ],
            "type": [
                2
            ],
            "postingNumber": [
                2
            ],
            "productName": [
                2
            ],
            "sku": [
                2
            ],
            "quantity": [
                9
            ],
            "price": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingAccrualsTotalsOutput": {
            "accrualsForSale": [
                32
            ],
            "saleCommission": [
                32
            ],
            "processingAndDelivery": [
                32
            ],
            "refundsAndCancellations": [
                32
            ],
            "servicesAmount": [
                32
            ],
            "compensationAmount": [
                32
            ],
            "moneyTransfer": [
                32
            ],
            "othersAmount": [
                32
            ],
            "deliveryCharge": [
                32
            ],
            "returnDeliveryCharge": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingFinancialDataOutput": {
            "products": [
                404
            ],
            "clusterFrom": [
                2
            ],
            "clusterTo": [
                2
            ],
            "syncedAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingFinancialDataProductOutput": {
            "productId": [
                2
            ],
            "commissionAmount": [
                32
            ],
            "commissionPercent": [
                32
            ],
            "payout": [
                32
            ],
            "oldPrice": [
                32
            ],
            "price": [
                32
            ],
            "totalDiscountValue": [
                32
            ],
            "totalDiscountPercent": [
                32
            ],
            "customerPrice": [
                32
            ],
            "currencyCode": [
                2
            ],
            "customerCurrencyCode": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingGetSyncRunListOutput": {
            "items": [
                406
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingGetSyncRunOutput": {
            "id": [
                9
            ],
            "status": [
                2
            ],
            "periodFrom": [
                5
            ],
            "periodTo": [
                5
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "totalPlanned": [
                9
            ],
            "totalSuccess": [
                9
            ],
            "totalFailed": [
                9
            ],
            "errorSummary": [
                2
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListOzonPostingGetSyncRunsInput": {
            "accountId": [
                9
            ],
            "page": [
                9
            ],
            "size": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingGetSyncRunItemOutput": {
            "id": [
                9
            ],
            "postingNumber": [
                2
            ],
            "scheme": [
                2
            ],
            "status": [
                2
            ],
            "attempt": [
                9
            ],
            "error": [
                2
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "OzonPostingAutoSyncTaskOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "status": [
                2
            ],
            "intervalMinutes": [
                9
            ],
            "lookbackDays": [
                9
            ],
            "syncGetData": [
                3
            ],
            "includeFboGet": [
                3
            ],
            "includeFbsGet": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "jobId": [
                2
            ],
            "lastRunAt": [
                5
            ],
            "nextRunAt": [
                5
            ],
            "lastError": [
                2
            ],
            "accountId": [
                9
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListOzonPostingAutoSyncTasksInput": {
            "accountId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ActionsOzonPosting": {},
        "ListWbSellerAccount": {
            "items": [
                413
            ],
            "counters": [
                414
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputWbSellerAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "hasApiKey": [
                3
            ],
            "lastSyncAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersWbSellerAccount": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputWbSellerAccount": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputWbSellerAccount": {
            "by": [
                14
            ],
            "order": [
                417
            ],
            "__typename": [
                2
            ]
        },
        "OrderWbSellerAccount": {},
        "CategoriesWbSellerAccount": {},
        "ItemOutputWbSellerAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "hasApiKey": [
                3
            ],
            "lastSyncAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsWbSellerAccount": {},
        "ListWbPosting": {
            "items": [
                422
            ],
            "counters": [
                426
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputWbPosting": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "postingNumber": [
                2
            ],
            "orderId": [
                2
            ],
            "orderNumber": [
                2
            ],
            "scheme": [
                423
            ],
            "status": [
                2
            ],
            "substatus": [
                2
            ],
            "inProcessAt": [
                5
            ],
            "shipmentDate": [
                5
            ],
            "warehouseId": [
                2
            ],
            "warehouseName": [
                2
            ],
            "isExpress": [
                3
            ],
            "rawPayloadJson": [
                2
            ],
            "syncedAt": [
                5
            ],
            "account": [
                424
            ],
            "products": [
                425
            ],
            "taxBaseFromCustomerPrice": [
                32
            ],
            "orderProfitRub": [
                32
            ],
            "taxBaseCustomerCurrencyCode": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SchemeWbPosting": {},
        "WbSellerAccountShortOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingProductOutput": {
            "id": [
                9
            ],
            "offerId": [
                2
            ],
            "sku": [
                2
            ],
            "productId": [
                2
            ],
            "name": [
                2
            ],
            "quantity": [
                9
            ],
            "price": [
                2
            ],
            "oldPrice": [
                2
            ],
            "currencyCode": [
                2
            ],
            "customerPrice": [
                32
            ],
            "customerCurrencyCode": [
                2
            ],
            "commissionAmount": [
                32
            ],
            "commissionPercent": [
                32
            ],
            "payout": [
                32
            ],
            "totalDiscountValue": [
                32
            ],
            "totalDiscountPercent": [
                32
            ],
            "imageUrl": [
                2
            ],
            "previewUrl": [
                2
            ],
            "product": [
                42
            ],
            "snapshotCostPriceRub": [
                32
            ],
            "snapshotCostProductId": [
                9
            ],
            "snapshotCostPricedAt": [
                5
            ],
            "effectiveUnitCostRub": [
                32
            ],
            "lineCostRub": [
                32
            ],
            "rawPayloadJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersWbPosting": {
            "all": [
                9
            ],
            "awaiting": [
                9
            ],
            "delivering": [
                9
            ],
            "delivered": [
                9
            ],
            "cancelled": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputWbPosting": {
            "search": [
                2
            ],
            "wbSellerAccountId": [
                9
            ],
            "status": [
                2
            ],
            "scheme": [
                423
            ],
            "warehouseId": [
                2
            ],
            "productId": [
                9
            ],
            "productName": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputWbPosting": {
            "by": [
                14
            ],
            "order": [
                429
            ],
            "__typename": [
                2
            ]
        },
        "OrderWbPosting": {},
        "CategoriesWbPosting": {},
        "ItemOutputWbPosting": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "postingNumber": [
                2
            ],
            "orderId": [
                2
            ],
            "orderNumber": [
                2
            ],
            "scheme": [
                423
            ],
            "status": [
                2
            ],
            "substatus": [
                2
            ],
            "inProcessAt": [
                5
            ],
            "shipmentDate": [
                5
            ],
            "warehouseId": [
                2
            ],
            "warehouseName": [
                2
            ],
            "isExpress": [
                3
            ],
            "rawPayloadJson": [
                2
            ],
            "syncedAt": [
                5
            ],
            "account": [
                424
            ],
            "products": [
                425
            ],
            "accruals": [
                432
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingAccrualsOutput": {
            "operations": [
                433
            ],
            "totals": [
                434
            ],
            "financialDataFromGet": [
                435
            ],
            "getPayloadJson": [
                2
            ],
            "totalFromOperations": [
                32
            ],
            "orderCostRubTotal": [
                32
            ],
            "orderProfitRub": [
                32
            ],
            "financePrioritySource": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "WbAccrualOperationOutput": {
            "operationId": [
                2
            ],
            "operationType": [
                2
            ],
            "operationDate": [
                2
            ],
            "operationTypeName": [
                2
            ],
            "amount": [
                32
            ],
            "type": [
                2
            ],
            "postingNumber": [
                2
            ],
            "productName": [
                2
            ],
            "sku": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingAccrualsTotalsOutput": {
            "accrualsForSale": [
                32
            ],
            "saleCommission": [
                32
            ],
            "processingAndDelivery": [
                32
            ],
            "refundsAndCancellations": [
                32
            ],
            "servicesAmount": [
                32
            ],
            "compensationAmount": [
                32
            ],
            "moneyTransfer": [
                32
            ],
            "othersAmount": [
                32
            ],
            "deliveryCharge": [
                32
            ],
            "returnDeliveryCharge": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingFinancialDataOutput": {
            "payloadJson": [
                2
            ],
            "syncedAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingGetSyncRunListOutput": {
            "total": [
                9
            ],
            "items": [
                437
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingGetSyncRunOutput": {
            "id": [
                9
            ],
            "status": [
                2
            ],
            "periodFrom": [
                5
            ],
            "periodTo": [
                5
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "totalPlanned": [
                9
            ],
            "totalSuccess": [
                9
            ],
            "totalFailed": [
                9
            ],
            "errorSummary": [
                2
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListWbPostingGetSyncRunsInput": {
            "accountId": [
                9
            ],
            "page": [
                9
            ],
            "size": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingGetSyncRunItemOutput": {
            "id": [
                9
            ],
            "postingNumber": [
                2
            ],
            "scheme": [
                2
            ],
            "status": [
                2
            ],
            "attempt": [
                9
            ],
            "error": [
                2
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "WbPostingAutoSyncTaskOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "status": [
                2
            ],
            "intervalMinutes": [
                9
            ],
            "lookbackDays": [
                9
            ],
            "syncGetData": [
                3
            ],
            "includeFbw": [
                3
            ],
            "includeFbs": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "jobId": [
                2
            ],
            "lastRunAt": [
                5
            ],
            "nextRunAt": [
                5
            ],
            "lastError": [
                2
            ],
            "accountId": [
                9
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListWbPostingAutoSyncTasksInput": {
            "accountId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ActionsWbPosting": {},
        "ListWbCatalogProduct": {
            "items": [
                444
            ],
            "counters": [
                446
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputWbCatalogProduct": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "status": [
                2
            ],
            "nmId": [
                2
            ],
            "vendorCode": [
                2
            ],
            "title": [
                2
            ],
            "brand": [
                2
            ],
            "category": [
                2
            ],
            "imageUrl": [
                2
            ],
            "photosJson": [
                2
            ],
            "rawPayloadJson": [
                2
            ],
            "syncedAt": [
                5
            ],
            "account": [
                445
            ],
            "linkedProductId": [
                9
            ],
            "linkedProduct": [
                42
            ],
            "__typename": [
                2
            ]
        },
        "WbCatalogSellerAccountShortOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersWbCatalogProduct": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputWbCatalogProduct": {
            "search": [
                2
            ],
            "wbSellerAccountId": [
                9
            ],
            "nmId": [
                2
            ],
            "vendorCode": [
                2
            ],
            "brand": [
                2
            ],
            "category": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputWbCatalogProduct": {
            "by": [
                14
            ],
            "order": [
                449
            ],
            "__typename": [
                2
            ]
        },
        "OrderWbCatalogProduct": {},
        "CategoriesWbCatalogProduct": {},
        "ItemOutputWbCatalogProduct": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "status": [
                2
            ],
            "nmId": [
                2
            ],
            "vendorCode": [
                2
            ],
            "title": [
                2
            ],
            "brand": [
                2
            ],
            "category": [
                2
            ],
            "imageUrl": [
                2
            ],
            "photosJson": [
                2
            ],
            "rawPayloadJson": [
                2
            ],
            "syncedAt": [
                5
            ],
            "account": [
                445
            ],
            "linkedProductId": [
                9
            ],
            "linkedProduct": [
                42
            ],
            "__typename": [
                2
            ]
        },
        "ActionsWbCatalogProduct": {},
        "WbCatalogSyncRunListOutput": {
            "total": [
                9
            ],
            "items": [
                454
            ],
            "__typename": [
                2
            ]
        },
        "WbCatalogSyncRunOutput": {
            "id": [
                9
            ],
            "status": [
                2
            ],
            "totalFetched": [
                9
            ],
            "totalUpserted": [
                9
            ],
            "errorSummary": [
                2
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListWbCatalogSyncRunsInput": {
            "accountId": [
                9
            ],
            "page": [
                9
            ],
            "size": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "WbCatalogAutoSyncTaskOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "status": [
                2
            ],
            "intervalMinutes": [
                9
            ],
            "pageLimit": [
                9
            ],
            "jobId": [
                2
            ],
            "lastRunAt": [
                5
            ],
            "nextRunAt": [
                5
            ],
            "lastError": [
                2
            ],
            "accountId": [
                9
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListWbCatalogAutoSyncTasksInput": {
            "accountId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListAvitoSellerAccount": {
            "items": [
                459
            ],
            "counters": [
                460
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputAvitoSellerAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "hasClientSecret": [
                3
            ],
            "lastSyncAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersAvitoSellerAccount": {
            "all": [
                9
            ],
            "active": [
                9
            ],
            "inactive": [
                9
            ],
            "drafts": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputAvitoSellerAccount": {
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputAvitoSellerAccount": {
            "by": [
                14
            ],
            "order": [
                463
            ],
            "__typename": [
                2
            ]
        },
        "OrderAvitoSellerAccount": {},
        "CategoriesAvitoSellerAccount": {},
        "ItemOutputAvitoSellerAccount": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "hasClientSecret": [
                3
            ],
            "lastSyncAt": [
                5
            ],
            "status": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionsAvitoSellerAccount": {},
        "ListAvitoPosting": {
            "items": [
                468
            ],
            "counters": [
                472
            ],
            "total": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ListOutputAvitoPosting": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "postingNumber": [
                2
            ],
            "marketplaceId": [
                2
            ],
            "scheme": [
                469
            ],
            "status": [
                2
            ],
            "category": [
                2
            ],
            "rawPayloadJson": [
                2
            ],
            "orderCreatedAt": [
                5
            ],
            "orderUpdatedAt": [
                5
            ],
            "syncedAt": [
                5
            ],
            "account": [
                470
            ],
            "products": [
                471
            ],
            "orderProfitRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "SchemeAvitoPosting": {},
        "AvitoSellerAccountShortOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "AvitoPostingProductOutput": {
            "id": [
                9
            ],
            "offerId": [
                2
            ],
            "avitoItemId": [
                2
            ],
            "productId": [
                2
            ],
            "name": [
                2
            ],
            "quantity": [
                9
            ],
            "price": [
                2
            ],
            "currencyCode": [
                2
            ],
            "imageUrl": [
                2
            ],
            "previewUrl": [
                2
            ],
            "product": [
                42
            ],
            "snapshotCostPriceRub": [
                32
            ],
            "snapshotCostProductId": [
                9
            ],
            "snapshotCostPricedAt": [
                5
            ],
            "effectiveUnitCostRub": [
                32
            ],
            "lineCostRub": [
                32
            ],
            "rawPayloadJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "CountersAvitoPosting": {
            "all": [
                9
            ],
            "awaiting": [
                9
            ],
            "delivering": [
                9
            ],
            "delivered": [
                9
            ],
            "cancelled": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "FilterInputAvitoPosting": {
            "search": [
                2
            ],
            "avitoSellerAccountId": [
                9
            ],
            "status": [
                2
            ],
            "scheme": [
                469
            ],
            "productId": [
                9
            ],
            "productName": [
                2
            ],
            "marketplaceId": [
                2
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "SortingInputAvitoPosting": {
            "by": [
                14
            ],
            "order": [
                475
            ],
            "__typename": [
                2
            ]
        },
        "OrderAvitoPosting": {},
        "CategoriesAvitoPosting": {},
        "ItemOutputAvitoPosting": {
            "id": [
                9
            ],
            "createdAt": [
                5
            ],
            "updatedAt": [
                5
            ],
            "postingNumber": [
                2
            ],
            "marketplaceId": [
                2
            ],
            "scheme": [
                469
            ],
            "status": [
                2
            ],
            "category": [
                2
            ],
            "rawPayloadJson": [
                2
            ],
            "orderCreatedAt": [
                5
            ],
            "orderUpdatedAt": [
                5
            ],
            "syncedAt": [
                5
            ],
            "account": [
                470
            ],
            "products": [
                471
            ],
            "financialPayloadJson": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "AvitoPostingGetSyncRunListOutput": {
            "total": [
                9
            ],
            "items": [
                479
            ],
            "__typename": [
                2
            ]
        },
        "AvitoPostingGetSyncRunOutput": {
            "id": [
                9
            ],
            "status": [
                2
            ],
            "periodFrom": [
                5
            ],
            "periodTo": [
                5
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "totalPlanned": [
                9
            ],
            "totalSuccess": [
                9
            ],
            "totalFailed": [
                9
            ],
            "errorSummary": [
                2
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListAvitoPostingGetSyncRunsInput": {
            "accountId": [
                9
            ],
            "page": [
                9
            ],
            "size": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "AvitoPostingGetSyncRunItemOutput": {
            "id": [
                9
            ],
            "postingNumber": [
                2
            ],
            "scheme": [
                2
            ],
            "status": [
                2
            ],
            "attempt": [
                9
            ],
            "error": [
                2
            ],
            "startedAt": [
                5
            ],
            "finishedAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "AvitoPostingAutoSyncTaskOutput": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "status": [
                2
            ],
            "intervalMinutes": [
                9
            ],
            "lookbackDays": [
                9
            ],
            "syncGetData": [
                3
            ],
            "includePvz": [
                3
            ],
            "includeDbs": [
                3
            ],
            "includeRdbs": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "jobId": [
                2
            ],
            "lastRunAt": [
                5
            ],
            "nextRunAt": [
                5
            ],
            "lastError": [
                2
            ],
            "accountId": [
                9
            ],
            "createdAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ListAvitoPostingAutoSyncTasksInput": {
            "accountId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ActionsAvitoPosting": {},
        "Mutation": {
            "login": [
                486,
                {
                    "email": [
                        2,
                        "String!"
                    ],
                    "password": [
                        2,
                        "String!"
                    ]
                }
            ],
            "relogin": [
                486,
                {
                    "refresh_token": [
                        2,
                        "String!"
                    ]
                }
            ],
            "changePassword": [
                3,
                {
                    "oldPassword": [
                        2,
                        "String!"
                    ],
                    "newPassword": [
                        2,
                        "String!"
                    ]
                }
            ],
            "updateOneUser": [
                1,
                {
                    "displayName": [
                        2
                    ],
                    "showInterfaceSettings": [
                        3
                    ]
                }
            ],
            "logOut": [
                3
            ],
            "deleteSession": [
                4,
                {
                    "id": [
                        32,
                        "Float!"
                    ]
                }
            ],
            "uploadUserAvatar": [
                2,
                {
                    "file": [
                        487,
                        "Upload!"
                    ]
                }
            ],
            "createUser": [
                8,
                {
                    "data": [
                        488,
                        "DataInputUser!"
                    ]
                }
            ],
            "updateUser": [
                8,
                {
                    "data": [
                        489,
                        "DataInputUserUpdate!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "banUser": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "unbanUser": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createStorage": [
                19,
                {
                    "data": [
                        491,
                        "DataInputStorage!"
                    ]
                }
            ],
            "importStorage": [
                492,
                {
                    "data": [
                        491,
                        "[DataInputStorage!]!"
                    ]
                }
            ],
            "updateStorage": [
                19,
                {
                    "data": [
                        491,
                        "DataInputStorage!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteStorage": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateStorage": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateStorage": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncStorage": [
                490,
                {
                    "data": [
                        493,
                        "SyncDictionaryInput!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deleteGSheetsSyncStorage": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProduct": [
                40,
                {
                    "data": [
                        495,
                        "ItemInputProduct!"
                    ]
                }
            ],
            "importProduct": [
                492,
                {
                    "data": [
                        495,
                        "[ItemInputProduct!]!"
                    ]
                }
            ],
            "updateProduct": [
                40,
                {
                    "data": [
                        495,
                        "ItemInputProduct!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProduct": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProduct": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProduct": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncProduct": [
                490,
                {
                    "data": [
                        493,
                        "SyncDictionaryInput!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deleteGSheetsSyncProduct": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "addToSiteProduct": [
                490,
                {
                    "data": [
                        497,
                        "AddToSiteInputProduct!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProductBrand": [
                45,
                {
                    "data": [
                        498,
                        "DataInputProductBrand!"
                    ]
                }
            ],
            "importProductBrand": [
                492,
                {
                    "data": [
                        498,
                        "[DataInputProductBrand!]!"
                    ]
                }
            ],
            "updateProductBrand": [
                45,
                {
                    "data": [
                        498,
                        "DataInputProductBrand!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProductBrand": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProductBrand": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProductBrand": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createCheckPriceMonitor": [
                59,
                {
                    "data": [
                        499,
                        "ItemInputCheckPriceMonitor!"
                    ]
                }
            ],
            "importCheckPriceMonitor": [
                492,
                {
                    "data": [
                        499,
                        "[ItemInputCheckPriceMonitor!]!"
                    ]
                }
            ],
            "updateCheckPriceMonitor": [
                59,
                {
                    "data": [
                        499,
                        "ItemInputCheckPriceMonitor!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteCheckPriceMonitor": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateCheckPriceMonitor": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateCheckPriceMonitor": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createCheckPriceLink": [
                69,
                {
                    "data": [
                        500,
                        "ItemInputCheckPriceLink!"
                    ]
                }
            ],
            "importCheckPriceLink": [
                492,
                {
                    "data": [
                        500,
                        "[ItemInputCheckPriceLink!]!"
                    ]
                }
            ],
            "updateCheckPriceLink": [
                69,
                {
                    "data": [
                        500,
                        "ItemInputCheckPriceLink!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteCheckPriceLink": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateCheckPriceLink": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateCheckPriceLink": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProductCategory": [
                79,
                {
                    "data": [
                        501,
                        "ItemInputProductCategory!"
                    ]
                }
            ],
            "importProductCategory": [
                492,
                {
                    "data": [
                        501,
                        "[ItemInputProductCategory!]!"
                    ]
                }
            ],
            "updateProductCategory": [
                79,
                {
                    "data": [
                        501,
                        "ItemInputProductCategory!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProductCategory": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProductCategory": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProductCategory": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createStorageDocuments": [
                116,
                {
                    "data": [
                        502,
                        "ItemInputStorageDocuments!"
                    ]
                }
            ],
            "updateStorageDocuments": [
                116,
                {
                    "data": [
                        502,
                        "ItemInputStorageDocuments!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteStorageDocuments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateStorageDocuments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateStorageDocuments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncStorageDocuments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createStorageShipments": [
                128,
                {
                    "data": [
                        504,
                        "ItemInputStorageShipments!"
                    ]
                }
            ],
            "updateStorageShipments": [
                128,
                {
                    "data": [
                        504,
                        "ItemInputStorageShipments!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteStorageShipments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateStorageShipments": [
                490,
                {
                    "data": [
                        506,
                        "ActivateStorageShipmentsData!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateStorageShipments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "payStorageShipments": [
                490,
                {
                    "data": [
                        507,
                        "PayStorageShipmentsData!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deliverStorageShipments": [
                490,
                {
                    "data": [
                        508,
                        "DeliverStorageShipmentsData!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "workStorageShipments": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createI18nLang": [
                135,
                {
                    "data": [
                        509,
                        "DataInputI18nLang!"
                    ]
                }
            ],
            "importI18nLang": [
                492,
                {
                    "data": [
                        509,
                        "[DataInputI18nLang!]!"
                    ]
                }
            ],
            "updateI18nLang": [
                135,
                {
                    "data": [
                        509,
                        "DataInputI18nLang!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteI18nLang": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateI18nLang": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateI18nLang": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createI18nKey": [
                144,
                {
                    "data": [
                        510,
                        "DataInputI18nKey!"
                    ]
                }
            ],
            "updateI18nKey": [
                144,
                {
                    "data": [
                        510,
                        "DataInputI18nKey!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteI18nKey": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateI18nKey": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateI18nKey": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "smartEditI18nKey": [
                490,
                {
                    "data": [
                        512,
                        "SmartEditInputI18nKey!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createAccount": [
                161,
                {
                    "data": [
                        513,
                        "ItemInputAccount!"
                    ]
                }
            ],
            "importAccount": [
                492,
                {
                    "data": [
                        513,
                        "[ItemInputAccount!]!"
                    ]
                }
            ],
            "updateAccount": [
                161,
                {
                    "data": [
                        513,
                        "ItemInputAccount!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteAccount": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateAccount": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateAccount": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncAccount": [
                490,
                {
                    "data": [
                        493,
                        "SyncDictionaryInput!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deleteGSheetsSyncAccount": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createTransactionArticles": [
                176,
                {
                    "data": [
                        514,
                        "ItemInputTransactionArticles!"
                    ]
                }
            ],
            "importTransactionArticles": [
                492,
                {
                    "data": [
                        514,
                        "[ItemInputTransactionArticles!]!"
                    ]
                }
            ],
            "updateTransactionArticles": [
                176,
                {
                    "data": [
                        514,
                        "ItemInputTransactionArticles!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteTransactionArticles": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateTransactionArticles": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateTransactionArticles": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncTransactionArticles": [
                490,
                {
                    "data": [
                        493,
                        "SyncDictionaryInput!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deleteGSheetsSyncTransactionArticles": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createTransactions": [
                191,
                {
                    "data": [
                        515,
                        "ItemInputTransactions!"
                    ]
                }
            ],
            "importTransactions": [
                492,
                {
                    "data": [
                        515,
                        "[ItemInputTransactions!]!"
                    ]
                }
            ],
            "updateTransactions": [
                191,
                {
                    "data": [
                        515,
                        "ItemInputTransactions!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteTransactions": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateTransactions": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateTransactions": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncTransactions": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSales": [
                204,
                {
                    "data": [
                        516,
                        "ItemInputSales!"
                    ]
                }
            ],
            "updateSales": [
                204,
                {
                    "data": [
                        516,
                        "ItemInputSales!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSales": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSales": [
                490,
                {
                    "data": [
                        518,
                        "ActivateSalesData!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSales": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "paySales": [
                490,
                {
                    "data": [
                        519,
                        "PaySalesData!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deliverSales": [
                490,
                {
                    "data": [
                        520,
                        "DeliverSalesData!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "workSales": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncSales": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSourceOrders": [
                218,
                {
                    "data": [
                        521,
                        "ItemInputSourceOrders!"
                    ]
                }
            ],
            "importSourceOrders": [
                492,
                {
                    "data": [
                        521,
                        "[ItemInputSourceOrders!]!"
                    ]
                }
            ],
            "updateSourceOrders": [
                218,
                {
                    "data": [
                        521,
                        "ItemInputSourceOrders!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSourceOrders": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSourceOrders": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSourceOrders": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncSourceOrders": [
                490,
                {
                    "data": [
                        493,
                        "SyncDictionaryInput!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deleteGSheetsSyncSourceOrders": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createDeliveryServices": [
                239,
                {
                    "data": [
                        522,
                        "ItemInputDeliveryServices!"
                    ]
                }
            ],
            "importDeliveryServices": [
                492,
                {
                    "data": [
                        522,
                        "[ItemInputDeliveryServices!]!"
                    ]
                }
            ],
            "updateDeliveryServices": [
                239,
                {
                    "data": [
                        522,
                        "ItemInputDeliveryServices!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteDeliveryServices": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateDeliveryServices": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateDeliveryServices": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "gSheetsSyncDeliveryServices": [
                490,
                {
                    "data": [
                        493,
                        "SyncDictionaryInput!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deleteGSheetsSyncDeliveryServices": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesScroller": [
                248,
                {
                    "data": [
                        523,
                        "ItemInputSitesScroller!"
                    ]
                }
            ],
            "updateSitesScroller": [
                248,
                {
                    "data": [
                        523,
                        "ItemInputSitesScroller!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesScroller": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesScroller": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesScroller": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "buildSitesScroller": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesPages": [
                257,
                {
                    "data": [
                        524,
                        "ItemInputSitesPages!"
                    ]
                }
            ],
            "updateSitesPages": [
                257,
                {
                    "data": [
                        524,
                        "ItemInputSitesPages!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesPages": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesPages": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesPages": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "smartEditSitesPages": [
                490,
                {
                    "data": [
                        525,
                        "SmartEditInputSitesPages!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesNews": [
                268,
                {
                    "data": [
                        526,
                        "ItemInputSitesNews!"
                    ]
                }
            ],
            "updateSitesNews": [
                268,
                {
                    "data": [
                        526,
                        "ItemInputSitesNews!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesNews": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesNews": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesNews": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesShopCategories": [
                278,
                {
                    "data": [
                        527,
                        "ItemInputSitesShopCategories!"
                    ]
                }
            ],
            "updateSitesShopCategories": [
                278,
                {
                    "data": [
                        527,
                        "ItemInputSitesShopCategories!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesShopCategories": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesShopCategories": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesShopCategories": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "smartEditSitesShopCategories": [
                490,
                {
                    "data": [
                        528,
                        "SmartEditInputSitesShopCategories!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesShopProducts": [
                291,
                {
                    "data": [
                        529,
                        "ItemInputSitesShopProducts!"
                    ]
                }
            ],
            "updateSitesShopProducts": [
                291,
                {
                    "data": [
                        529,
                        "ItemInputSitesShopProducts!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesShopProducts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesShopProducts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesShopProducts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "smartEditSitesShopProducts": [
                490,
                {
                    "data": [
                        530,
                        "SmartEditInputSitesShopProducts!"
                    ],
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesShopPayment": [
                302,
                {
                    "data": [
                        531,
                        "ItemInputSitesShopPayment!"
                    ]
                }
            ],
            "updateSitesShopPayment": [
                302,
                {
                    "data": [
                        531,
                        "ItemInputSitesShopPayment!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesShopPayment": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesShopPayment": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesShopPayment": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createSitesShopDelivery": [
                311,
                {
                    "data": [
                        532,
                        "ItemInputSitesShopDelivery!"
                    ]
                }
            ],
            "updateSitesShopDelivery": [
                311,
                {
                    "data": [
                        532,
                        "ItemInputSitesShopDelivery!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteSitesShopDelivery": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateSitesShopDelivery": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateSitesShopDelivery": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createGroups": [
                321,
                {
                    "data": [
                        533,
                        "ItemInputGroups!"
                    ]
                }
            ],
            "importGroups": [
                492,
                {
                    "data": [
                        533,
                        "[ItemInputGroups!]!"
                    ]
                }
            ],
            "updateGroups": [
                321,
                {
                    "data": [
                        533,
                        "ItemInputGroups!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteGroups": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateGroups": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateGroups": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProcurementSupplier": [
                324,
                {
                    "data": [
                        534,
                        "DataInputProcurementSupplier!"
                    ]
                }
            ],
            "updateProcurementSupplier": [
                324,
                {
                    "data": [
                        534,
                        "DataInputProcurementSupplier!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProcurementSupplier": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProcurementSupplier": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProcurementSupplier": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProcurementRequest": [
                332,
                {
                    "data": [
                        535,
                        "ItemInputProcurementRequest!"
                    ]
                }
            ],
            "updateProcurementRequest": [
                332,
                {
                    "data": [
                        535,
                        "ItemInputProcurementRequest!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "patchProcurementRequestExpenses": [
                332,
                {
                    "expensesComment": [
                        2
                    ],
                    "expenses": [
                        537,
                        "[ItemInputProcurementRequestExpense!]!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProcurementRequest": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProcurementRequest": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProcurementRequest": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProcurementContract": [
                352,
                {
                    "data": [
                        538,
                        "ItemInputProcurementContract!"
                    ]
                }
            ],
            "updateProcurementContract": [
                352,
                {
                    "data": [
                        538,
                        "ItemInputProcurementContract!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProcurementContract": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProcurementContract": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProcurementContract": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createProcurementDelivery": [
                355,
                {
                    "data": [
                        539,
                        "ItemInputProcurementDelivery!"
                    ]
                }
            ],
            "updateProcurementDelivery": [
                355,
                {
                    "data": [
                        539,
                        "ItemInputProcurementDelivery!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "patchProcurementDeliveryBoxes": [
                355,
                {
                    "boxes": [
                        542,
                        "[ItemInputProcurementDeliveryBox!]!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "patchProcurementDeliveryItems": [
                355,
                {
                    "items": [
                        540,
                        "[ItemInputProcurementDeliveryItem!]!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "patchProcurementDeliveryExpenses": [
                355,
                {
                    "expensesComment": [
                        2
                    ],
                    "expenses": [
                        544,
                        "[ItemInputProcurementDeliveryExpense!]!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "patchProcurementDeliveryShipmentData": [
                355,
                {
                    "data": [
                        545,
                        "SaveShipmentDataInput!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "saveShipmentAndCreateStorageShipment": [
                355,
                {
                    "shipment": [
                        546,
                        "SaveShipmentAndCreateStorageShipmentInput!"
                    ],
                    "deliveryId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "removeShipmentFromDelivery": [
                355,
                {
                    "shipmentIndex": [
                        9,
                        "Int!"
                    ],
                    "deliveryId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteProcurementDelivery": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateProcurementDelivery": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateProcurementDelivery": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createDocumentTemplate": [
                373,
                {
                    "data": [
                        548,
                        "DataInputDocumentTemplate!"
                    ]
                }
            ],
            "updateDocumentTemplate": [
                373,
                {
                    "data": [
                        548,
                        "DataInputDocumentTemplate!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteDocumentTemplate": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateDocumentTemplate": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateDocumentTemplate": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "createOzonSellerAccounts": [
                387,
                {
                    "data": [
                        549,
                        "ItemInputOzonSellerAccount!"
                    ]
                }
            ],
            "updateOzonSellerAccounts": [
                387,
                {
                    "data": [
                        549,
                        "ItemInputOzonSellerAccount!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteOzonSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateOzonSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateOzonSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "syncOzonPostings": [
                492,
                {
                    "data": [
                        550,
                        "SyncOzonPostingsInput!"
                    ]
                }
            ],
            "createOzonPostingAutoSyncTask": [
                409,
                {
                    "data": [
                        551,
                        "CreateOzonPostingAutoSyncTaskInput!"
                    ]
                }
            ],
            "stopOzonPostingAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteOzonPostingAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "createWbSellerAccounts": [
                419,
                {
                    "data": [
                        552,
                        "ItemInputWbSellerAccount!"
                    ]
                }
            ],
            "updateWbSellerAccounts": [
                419,
                {
                    "data": [
                        552,
                        "ItemInputWbSellerAccount!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteWbSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateWbSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateWbSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "syncWbPostings": [
                492,
                {
                    "data": [
                        553,
                        "SyncWbPostingsInput!"
                    ]
                }
            ],
            "createWbPostingAutoSyncTask": [
                440,
                {
                    "data": [
                        554,
                        "CreateWbPostingAutoSyncTaskInput!"
                    ]
                }
            ],
            "stopWbPostingAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteWbPostingAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "cancelWbPostingGetSyncRun": [
                3,
                {
                    "runId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "syncWbCatalogProducts": [
                492,
                {
                    "data": [
                        555,
                        "SyncWbCatalogProductsInput!"
                    ]
                }
            ],
            "createWbCatalogAutoSyncTask": [
                456,
                {
                    "data": [
                        556,
                        "CreateWbCatalogAutoSyncTaskInput!"
                    ]
                }
            ],
            "stopWbCatalogAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteWbCatalogAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "createAvitoSellerAccounts": [
                465,
                {
                    "data": [
                        557,
                        "ItemInputAvitoSellerAccount!"
                    ]
                }
            ],
            "updateAvitoSellerAccounts": [
                465,
                {
                    "data": [
                        557,
                        "ItemInputAvitoSellerAccount!"
                    ],
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteAvitoSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "activateAvitoSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "deactivateAvitoSellerAccounts": [
                490,
                {
                    "ids": [
                        9,
                        "[Int!]!"
                    ]
                }
            ],
            "syncAvitoPostings": [
                492,
                {
                    "data": [
                        558,
                        "SyncAvitoPostingsInput!"
                    ]
                }
            ],
            "createAvitoPostingAutoSyncTask": [
                482,
                {
                    "data": [
                        559,
                        "CreateAvitoPostingAutoSyncTaskInput!"
                    ]
                }
            ],
            "stopAvitoPostingAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "deleteAvitoPostingAutoSyncTask": [
                3,
                {
                    "id": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "cancelAvitoPostingGetSyncRun": [
                3,
                {
                    "runId": [
                        9,
                        "Int!"
                    ]
                }
            ],
            "__typename": [
                2
            ]
        },
        "LoginInfo": {
            "access_token": [
                2
            ],
            "refresh_token": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "Upload": {},
        "DataInputUser": {
            "email": [
                2
            ],
            "password": [
                2
            ],
            "displayName": [
                2
            ],
            "role": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "DataInputUserUpdate": {
            "displayName": [
                2
            ],
            "role": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ActionResult": {
            "succeed": [
                9
            ],
            "failed": [
                9
            ],
            "count": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "DataInputStorage": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "address": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ImportResult": {
            "count": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SyncDictionaryInput": {
            "syncData": [
                494
            ],
            "__typename": [
                2
            ]
        },
        "SyncDictionaryItem": {
            "id": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProduct": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "rrc": [
                32
            ],
            "oldPrice": [
                32
            ],
            "hsCode": [
                2
            ],
            "width": [
                9
            ],
            "length": [
                9
            ],
            "height": [
                9
            ],
            "weight": [
                32
            ],
            "volume": [
                32
            ],
            "shortDescription": [
                2
            ],
            "barcodes": [
                2
            ],
            "articles": [
                2
            ],
            "products": [
                496
            ],
            "images": [
                2
            ],
            "productBrand_id": [
                32
            ],
            "productCategory_id": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ProductInput": {
            "id": [
                9
            ],
            "count": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "AddToSiteInputProduct": {
            "site_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "DataInputProductBrand": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputCheckPriceMonitor": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "checkProductRrc": [
                3
            ],
            "ourPrice": [
                32
            ],
            "product_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputCheckPriceLink": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "url": [
                2
            ],
            "parserType": [
                2
            ],
            "selector": [
                2
            ],
            "checkPriceMonitor_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProductCategory": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "parent_id": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputStorageDocuments": {
            "comment": [
                2
            ],
            "storageInId": [
                9
            ],
            "storageOutId": [
                9
            ],
            "products": [
                503
            ],
            "__typename": [
                2
            ]
        },
        "StorageDocumentsProductInput": {
            "id": [
                9
            ],
            "count": [
                9
            ],
            "costPriceRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputStorageShipments": {
            "documentNumber": [
                2
            ],
            "gtd": [
                2
            ],
            "documentDate": [
                5
            ],
            "currency": [
                2
            ],
            "rate": [
                32
            ],
            "comment": [
                2
            ],
            "additionalPrice": [
                32
            ],
            "deliveryPrice": [
                32
            ],
            "swiftPrice": [
                32
            ],
            "additionalComment": [
                2
            ],
            "products": [
                505
            ],
            "__typename": [
                2
            ]
        },
        "StorageShipmentsProductInput": {
            "id": [
                9
            ],
            "count": [
                9
            ],
            "unitPrice": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ActivateStorageShipmentsData": {
            "storageId": [
                9
            ],
            "transactionArticlesId": [
                9
            ],
            "accountOutId": [
                9
            ],
            "markAsPaidOnly": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "PayStorageShipmentsData": {
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "transactionArticlesId": [
                9
            ],
            "currency": [
                2
            ],
            "accountInId": [
                9
            ],
            "accountOutId": [
                9
            ],
            "markAsPaidOnly": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "DeliverStorageShipmentsData": {
            "storageId": [
                9
            ],
            "comment": [
                2
            ],
            "products": [
                496
            ],
            "__typename": [
                2
            ]
        },
        "DataInputI18nLang": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "DataInputI18nKey": {
            "key": [
                2
            ],
            "originalTranslation": [
                2
            ],
            "i18n": [
                511
            ],
            "__typename": [
                2
            ]
        },
        "I18nLangInput": {
            "id": [
                9
            ],
            "translation": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SmartEditInputI18nKey": {
            "source": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputAccount": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "code": [
                2
            ],
            "currency": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputTransactionArticles": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "code": [
                2
            ],
            "fixedPercent": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputTransactions": {
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "transactionArticlesId": [
                9
            ],
            "currency": [
                2
            ],
            "accountInId": [
                9
            ],
            "accountOutId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSales": {
            "deliveryType_id": [
                9
            ],
            "paymentAccount_id": [
                9
            ],
            "deliveryFromStorage_id": [
                9
            ],
            "withSPB": [
                3
            ],
            "withOnline": [
                3
            ],
            "withReceipt": [
                3
            ],
            "buyerPhone": [
                2
            ],
            "buyerName": [
                2
            ],
            "sourceOrderNumber": [
                2
            ],
            "buyerEmail": [
                2
            ],
            "sourceOrder_id": [
                9
            ],
            "comment": [
                2
            ],
            "discountRub": [
                32
            ],
            "deliveryService_id": [
                32
            ],
            "deliveryNumber": [
                2
            ],
            "deliveryCity": [
                2
            ],
            "deliveryAddress": [
                2
            ],
            "deliveryPriceRub": [
                32
            ],
            "deliveryFromAccount_id": [
                9
            ],
            "includeDeliveryPriceRub": [
                32
            ],
            "products": [
                517
            ],
            "__typename": [
                2
            ]
        },
        "SalesProductInput": {
            "id": [
                9
            ],
            "count": [
                9
            ],
            "totalPriceRub": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ActivateSalesData": {
            "storageId": [
                9
            ],
            "transactionArticlesId": [
                9
            ],
            "accountInId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "PaySalesData": {
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "transactionArticlesId": [
                9
            ],
            "currency": [
                2
            ],
            "accountInId": [
                9
            ],
            "accountOutId": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "DeliverSalesData": {
            "storageId": [
                9
            ],
            "comment": [
                2
            ],
            "products": [
                496
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSourceOrders": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputDeliveryServices": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesScroller": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "hasShop": [
                3
            ],
            "hasNews": [
                3
            ],
            "shopSlug": [
                2
            ],
            "shopTitle": [
                2
            ],
            "newsSlug": [
                2
            ],
            "newsTitle": [
                2
            ],
            "cdnUrl": [
                2
            ],
            "shopCategorySections": [
                2
            ],
            "shopProductSections": [
                2
            ],
            "ftpHost": [
                2
            ],
            "ftpUser": [
                2
            ],
            "ftpPassword": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesPages": {
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "content": [
                2
            ],
            "links": [
                2
            ],
            "meta": [
                2
            ],
            "sections": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SmartEditInputSitesPages": {
            "source": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesNews": {
            "title": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "content": [
                2
            ],
            "publishedAt": [
                5
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesShopCategories": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "parent_id": [
                32
            ],
            "image": [
                2
            ],
            "icon": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SmartEditInputSitesShopCategories": {
            "source": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesShopProducts": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "slug": [
                2
            ],
            "description": [
                2
            ],
            "shortDescription": [
                2
            ],
            "images": [
                2
            ],
            "price": [
                32
            ],
            "product_id": [
                9
            ],
            "category_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "SmartEditInputSitesShopProducts": {
            "source": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesShopPayment": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputSitesShopDelivery": {
            "name": [
                2
            ],
            "site_id": [
                9
            ],
            "description": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputGroups": {
            "name": [
                2
            ],
            "role": [
                2
            ],
            "description": [
                2
            ],
            "permissions": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "DataInputProcurementSupplier": {
            "name": [
                2
            ],
            "nameNative": [
                2
            ],
            "nameEnglish": [
                2
            ],
            "nameRussian": [
                2
            ],
            "countryCode": [
                2
            ],
            "address": [
                2
            ],
            "addressNative": [
                2
            ],
            "addressEnglish": [
                2
            ],
            "addressRussian": [
                2
            ],
            "description": [
                2
            ],
            "contactName": [
                2
            ],
            "contactNameNative": [
                2
            ],
            "contactNameEnglish": [
                2
            ],
            "contactNameRussian": [
                2
            ],
            "phone": [
                2
            ],
            "email": [
                2
            ],
            "site": [
                2
            ],
            "taxIdentifier": [
                2
            ],
            "kpp": [
                2
            ],
            "ogrn": [
                2
            ],
            "bankAccountNumber": [
                2
            ],
            "bankCorrAccountNumber": [
                2
            ],
            "bankBic": [
                2
            ],
            "bankCnapsCode": [
                2
            ],
            "bankSwiftCode": [
                2
            ],
            "bankName": [
                2
            ],
            "bankAddress": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementRequest": {
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "comment": [
                2
            ],
            "importantNote": [
                2
            ],
            "supplier_id": [
                9
            ],
            "buyer_id": [
                9
            ],
            "contract_id": [
                9
            ],
            "currency": [
                2
            ],
            "tradeTerms": [
                2
            ],
            "request_status": [
                2
            ],
            "items": [
                536
            ],
            "expenses": [
                537
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementRequestItem": {
            "id": [
                9
            ],
            "product_id": [
                9
            ],
            "hsCode": [
                2
            ],
            "productName": [
                2
            ],
            "description": [
                2
            ],
            "quantity": [
                32
            ],
            "price": [
                32
            ],
            "amount": [
                32
            ],
            "comment": [
                2
            ],
            "sortOrder": [
                9
            ],
            "images": [
                2
            ],
            "imageSlotId": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementRequestExpense": {
            "id": [
                9
            ],
            "amount": [
                32
            ],
            "rate": [
                32
            ],
            "comment": [
                2
            ],
            "isPaymentForInvoice": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementContract": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "importantNote": [
                2
            ],
            "currency": [
                2
            ],
            "contract_number": [
                2
            ],
            "contract_date": [
                5
            ],
            "contract_amount": [
                32
            ],
            "contract_end_date": [
                5
            ],
            "supplier_id": [
                9
            ],
            "buyer_id": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementDelivery": {
            "documentNumber": [
                2
            ],
            "documentDate": [
                5
            ],
            "comment": [
                2
            ],
            "tradeTerms": [
                2
            ],
            "gtd": [
                2
            ],
            "contract_id": [
                9
            ],
            "request_ids": [
                9
            ],
            "items": [
                540
            ],
            "boxes": [
                542
            ],
            "expenses": [
                544
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementDeliveryItem": {
            "id": [
                9
            ],
            "product_id": [
                9
            ],
            "hsCode": [
                2
            ],
            "countryOfOrigin": [
                2
            ],
            "kitName": [
                2
            ],
            "description": [
                2
            ],
            "quantity": [
                32
            ],
            "price": [
                32
            ],
            "amount": [
                32
            ],
            "netWeightKg": [
                32
            ],
            "grossWeightKg": [
                32
            ],
            "sortOrder": [
                9
            ],
            "components": [
                541
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementDeliveryItemComponent": {
            "procurementRequestItemId": [
                9
            ],
            "quantity": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementDeliveryBox": {
            "id": [
                9
            ],
            "quantity": [
                9
            ],
            "hsCode": [
                2
            ],
            "countryOfOrigin": [
                2
            ],
            "description": [
                2
            ],
            "qtyPcs": [
                32
            ],
            "pricePerPcs": [
                32
            ],
            "amount": [
                32
            ],
            "weightPerBoxKg": [
                32
            ],
            "netWeightKg": [
                32
            ],
            "grossWeightKg": [
                32
            ],
            "lengthCm": [
                32
            ],
            "widthCm": [
                32
            ],
            "heightCm": [
                32
            ],
            "cubicMeterM3": [
                32
            ],
            "items": [
                543
            ],
            "sortOrder": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementDeliveryBoxItem": {
            "procurementDeliveryItemId": [
                9
            ],
            "itemIndex": [
                9
            ],
            "quantity": [
                32
            ],
            "netWeightKg": [
                32
            ],
            "grossWeightKg": [
                32
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputProcurementDeliveryExpense": {
            "id": [
                9
            ],
            "amount": [
                32
            ],
            "rate": [
                32
            ],
            "comment": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SaveShipmentDataInput": {
            "shipmentData": [
                356
            ],
            "__typename": [
                2
            ]
        },
        "SaveShipmentAndCreateStorageShipmentInput": {
            "gtd": [
                2
            ],
            "comment": [
                2
            ],
            "storageId": [
                9
            ],
            "items": [
                547
            ],
            "__typename": [
                2
            ]
        },
        "SaveShipmentAndCreateStorageShipmentItemInput": {
            "productId": [
                9
            ],
            "quantity": [
                32
            ],
            "unitPrice": [
                32
            ],
            "invTotal": [
                32
            ],
            "paymentTotal": [
                32
            ],
            "deliveryTotal": [
                32
            ],
            "reprice": [
                32
            ],
            "components": [
                541
            ],
            "__typename": [
                2
            ]
        },
        "DataInputDocumentTemplate": {
            "name": [
                2
            ],
            "description": [
                2
            ],
            "assetCode": [
                2
            ],
            "templateType": [
                2
            ],
            "pageOrientation": [
                2
            ],
            "templateHtml": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputOzonSellerAccount": {
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "apiKey": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SyncOzonPostingsInput": {
            "accountId": [
                9
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "syncGetData": [
                3
            ],
            "getDateFrom": [
                5
            ],
            "getDateTo": [
                5
            ],
            "includeFboGet": [
                3
            ],
            "includeFbsGet": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "CreateOzonPostingAutoSyncTaskInput": {
            "accountId": [
                9
            ],
            "intervalMinutes": [
                9
            ],
            "lookbackDays": [
                9
            ],
            "name": [
                2
            ],
            "syncGetData": [
                3
            ],
            "includeFboGet": [
                3
            ],
            "includeFbsGet": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputWbSellerAccount": {
            "name": [
                2
            ],
            "apiKey": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SyncWbPostingsInput": {
            "accountId": [
                9
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "syncGetData": [
                3
            ],
            "includeFbw": [
                3
            ],
            "includeFbs": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "CreateWbPostingAutoSyncTaskInput": {
            "accountId": [
                9
            ],
            "intervalMinutes": [
                9
            ],
            "lookbackDays": [
                9
            ],
            "name": [
                2
            ],
            "syncGetData": [
                3
            ],
            "includeFbw": [
                3
            ],
            "includeFbs": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "SyncWbCatalogProductsInput": {
            "accountId": [
                9
            ],
            "pageLimit": [
                9
            ],
            "__typename": [
                2
            ]
        },
        "CreateWbCatalogAutoSyncTaskInput": {
            "accountId": [
                9
            ],
            "intervalMinutes": [
                9
            ],
            "pageLimit": [
                9
            ],
            "name": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "ItemInputAvitoSellerAccount": {
            "name": [
                2
            ],
            "clientId": [
                2
            ],
            "clientSecret": [
                2
            ],
            "__typename": [
                2
            ]
        },
        "SyncAvitoPostingsInput": {
            "accountId": [
                9
            ],
            "dateFrom": [
                5
            ],
            "dateTo": [
                5
            ],
            "syncGetData": [
                3
            ],
            "includePvz": [
                3
            ],
            "includeDbs": [
                3
            ],
            "includeRdbs": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "__typename": [
                2
            ]
        },
        "CreateAvitoPostingAutoSyncTaskInput": {
            "accountId": [
                9
            ],
            "intervalMinutes": [
                9
            ],
            "lookbackDays": [
                9
            ],
            "name": [
                2
            ],
            "syncGetData": [
                3
            ],
            "includePvz": [
                3
            ],
            "includeDbs": [
                3
            ],
            "includeRdbs": [
                3
            ],
            "refreshCostPrices": [
                3
            ],
            "__typename": [
                2
            ]
        }
    }
};
